"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[393],{

/***/ 4393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ convert; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(933);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(8770);
// EXTERNAL MODULE: ./node_modules/swiper/modules/scrollbar/scrollbar.min.css
var scrollbar_min = __webpack_require__(3390);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(7357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(5861);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(9901);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(2546);
// EXTERNAL MODULE: ./src/config/env.ts
var env = __webpack_require__(5324);
// EXTERNAL MODULE: ./src/theme/index.ts + 18 modules
var theme = __webpack_require__(4166);
// EXTERNAL MODULE: ./src/components/@common/CustomImage/CustomImage.tsx
var CustomImage = __webpack_require__(5164);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(948);
;// CONCATENATED MODULE: ./src/components/@common/Carousel/Carousel.style.ts


const CarouselContainer = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: 0,
        padding: 0,
        width: "100%",
        height: "100%",
        position: "relative"
    };
// [theme.breakpoints.down('md')]: {
//   height: '66vh',
// },
});

;// CONCATENATED MODULE: ./src/components/@common/Carousel/Carousel.tsx














const Carousel = (param)=>{
    let { images , title , logo  } = param;
    var ref;
    const swiperOption = {
        slidesPerView: 1,
        loop: true,
        speed: 1200,
        autoplay: {
            delay: 4000
        },
        navigation: {
            nextEl: ".digi-nav-control .swiper-button-next",
            prevEl: ".digi-nav-control .swiper-button-prev"
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            zIndex: 99999
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CarouselContainer, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                sx: {
                    position: "absolute",
                    zIndex: 999,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "rgba(0,12,97,0.3)",
                    width: "100%",
                    height: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                        sx: {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            width: {
                                lg: "50%",
                                md: "40%",
                                sm: "40%",
                                xs: "40%"
                            },
                            maxHeight: "40%"
                        },
                        children: logo && Array.isArray(logo === null || logo === void 0 ? void 0 : (ref = logo.img) === null || ref === void 0 ? void 0 : ref.data) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomImage/* default */.Z, {
                            src: "".concat(env/* default.API_BASE */.Z.API_BASE).concat(logo.img.data[0].attributes.url, "?updatedAt=").concat(logo.img.data[0].attributes.updatedAt),
                            alt: logo.imgAlt || "",
                            width: logo.img.data[0].attributes.height,
                            height: logo.img.data[0].attributes.height
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                        fontWeight: 700,
                        color: theme/* theme.palette.neutral01.700 */.r.palette.neutral01[700],
                        variant: "heading01",
                        component: "h1",
                        children: title && title
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(swiper_react/* Swiper */.tq, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                effect: "coverflow"
            }, swiperOption), {
                modules: [
                    swiper_esm/* Navigation */.W_,
                    swiper_esm/* Autoplay */.pt,
                    swiper_esm/* Pagination */.tl,
                    swiper_esm/* EffectFade */.xW
                ],
                pagination: true,
                style: {
                    height: "100%",
                    width: "100%"
                },
                children: images && Array.isArray(images) && images.map((image)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(swiper_react/* SwiperSlide */.o5, {
                        title: image.imgAlt,
                        style: {
                            maxHeight: "76vh",
                            width: "100%"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                            sx: {
                                position: "relative",
                                width: "100%",
                                minHeight: {
                                    lg: "100%",
                                    md: "66vh",
                                    sm: "66vh",
                                    xs: "66vh"
                                },
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: 0,
                                margin: "auto",
                                objectFit: "cover",
                                "& > span": {
                                    position: "initial !important"
                                }
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomImage/* default */.Z, {
                                src: "".concat(env/* default.API_BASE */.Z.API_BASE).concat(image.img.data[0].attributes.url, "?updatedAt=").concat(image.img.data[0].attributes.updatedAt) || "",
                                alt: image.imgAlt || "",
                                width: image.img.data[0].attributes.width,
                                height: image.img.data[0].attributes.height,
                                style: {
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    bottom: 0,
                                    right: 0
                                },
                                objectFit: "cover"
                            })
                        })
                    }, image.id))
            }))
        ]
    });
};
/* harmony default export */ var Carousel_Carousel = (Carousel);

// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(5582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(1233);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 1 modules
var Button = __webpack_require__(2992);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(4487);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js + 1 modules
var Card = __webpack_require__(6242);
// EXTERNAL MODULE: ./node_modules/@mui/styles/makeStyles/makeStyles.js + 16 modules
var makeStyles = __webpack_require__(9572);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 3 modules
var parseISO = __webpack_require__(6250);
;// CONCATENATED MODULE: ./src/utils/convertDatetoImage.tsx








const useStyles = (0,makeStyles/* default */.Z)({
    card: {
        boxShadow: "none",
        backgroundColor: theme/* theme.palette.global01.700 */.r.palette.global01[700],
        borderRadius: "8px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: theme/* theme.spacing */.r.spacing(12),
        color: theme/* theme.palette.global01.400 */.r.palette.global01[400],
        fontWeight: "bold",
        padding: 8
    }
});
const ConvertDatetoImage = (param)=>{
    let { date , isHeroSection =false  } = param;
    const classes = useStyles();
    function getMonth(dateString) {
        const date = (0,parseISO/* default */.Z)(dateString);
        const month = date.getMonth() + 1;
        return month.toString().padStart(2, "0");
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.Z, {
        className: classes.card,
        sx: {
            width: isHeroSection ? "365px" : "48px",
            height: isHeroSection ? "361px" : "48px"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                    sx: {
                        fontSize: isHeroSection ? "8.625rem" : "18px",
                        fontWeight: isHeroSection ? "900" : "700"
                    },
                    component: "div",
                    children: (0,parseISO/* default */.Z)(date).getDate().toString().padStart(2, "0")
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                    sx: {
                        fontSize: isHeroSection ? "8.625rem" : "18px",
                        fontWeight: isHeroSection ? "900" : "700",
                        marginTop: isHeroSection ? "-50px" : "0px"
                    },
                    component: "div",
                    children: getMonth(date)
                })
            ]
        })
    });
};
/* harmony default export */ var convertDatetoImage = (ConvertDatetoImage);

// EXTERNAL MODULE: ./src/utils/localConvert.ts
var localConvert = __webpack_require__(2267);
// EXTERNAL MODULE: ./src/hooks/useLocale.ts + 2 modules
var useLocale = __webpack_require__(7398);
// EXTERNAL MODULE: ./src/hooks/useMedia.ts
var useMedia = __webpack_require__(2447);
// EXTERNAL MODULE: ./src/services/api/index.ts + 42 modules
var api = __webpack_require__(6169);
// EXTERNAL MODULE: ./src/components/@icons/index.ts + 148 modules
var _icons = __webpack_require__(9221);
// EXTERNAL MODULE: ./src/components/@common/CustomImage/index.ts
var _common_CustomImage = __webpack_require__(368);
;// CONCATENATED MODULE: ./src/components/@common/DefaultSection/DefaultSection.tsx



















const DefaultSection = (param)=>{
    let { icon , tagline , title , description , checks , primaryButton , secondaryButton , thirdButton , forthButton , openNewTabButton , image , margin ="both" , headerSize ="small" , imgMaxWidth , titleMaxWidth ="none" , isHeroSection =false , inverted =false , invertedMobile =false , getEvents =false , dateForEvent  } = param;
    const { isSmall , isMedium  } = (0,useMedia/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const { locale  } = (0,useLocale/* useLocale */.b)();
    const { eventSlug  } = router.query;
    const IcoCheckBoldGreen = (0,styled/* default */.ZP)(_icons/* IcoCheckBold */.zM)((param)=>{
        let { theme  } = param;
        return {
            color: theme.palette.success.main,
            minWidth: "24px",
            minHeight: "24px"
        };
    });
    const { 0: events , 1: setEvents  } = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        if (locale && getEvents) {
            loadData(localConvert/* languageCodeMap */.B[locale]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        locale,
        getEvents,
        eventSlug
    ]);
    const loadData = async (locale)=>{
        try {
            let getEvent;
            if (eventSlug) {
                getEvent = {
                    sort: {
                        date: "ASC"
                    },
                    locale: locale,
                    filters: {
                        url: {
                            $ne: "".concat(eventSlug)
                        }
                    }
                };
            } else {
                getEvent = {
                    sort: {
                        date: "ASC"
                    },
                    locale: locale
                };
            }
            const response = await api/* EventsService.getAllEvents */.nC.getAllEvents(lib_default().stringify(getEvent, {
                encodeValuesOnly: true
            }));
            if (response && (response === null || response === void 0 ? void 0 : response.data)) {
                if (Array.isArray(response === null || response === void 0 ? void 0 : response.data) && (response === null || response === void 0 ? void 0 : response.data.length) > 3) {
                    setEvents(response === null || response === void 0 ? void 0 : response.data.splice(0, 3));
                } else {
                    setEvents(response === null || response === void 0 ? void 0 : response.data);
                }
            } else {
                setEvents([]);
            }
        } catch (error) {
            esm_exports/* captureException */.Tb(error);
        // Even if the API failed, we still go to the next step, but hide description in the Organisation step
        } finally{}
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section, {
            component: "section",
            $margin: margin,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionLeft, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, !isMedium ? {
                    order: inverted ? 1 : 0
                } : {
                    order: invertedMobile ? 1 : 0
                }), {
                    $fullwidth: !image,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            tagline && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
                                direction: "row",
                                gap: 1,
                                sx: (theme)=>({
                                        color: theme.palette.neutral01[400],
                                        fill: theme.palette.neutral01[400]
                                    }),
                                children: [
                                    icon && /*#__PURE__*/ react.cloneElement(icon, {
                                        style: {
                                            width: "32px",
                                            height: "32px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                        variant: "heading04",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            id: tagline
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                gutterBottom: true,
                                variant: tagline || headerSize == "large" ? "heading01" : "heading03"
                            }, isHeroSection && {
                                component: "h1"
                            }), {
                                maxWidth: titleMaxWidth,
                                children: title
                            })),
                            description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
                                variant: "paragraph01",
                                children: description
                            }),
                            getEvents && events && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultSectionCards, {
                                $columns: 1,
                                children: events && events.map((event, i)=>{
                                    var ref, ref1;
                                    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DefaultSectionCard, {
                                        onClick: ()=>router.push("/events/".concat(event.attributes.url)),
                                        children: [
                                            ((ref = event.attributes) === null || ref === void 0 ? void 0 : ref.date) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(convertDatetoImage, {
                                                date: (ref1 = event.attributes) === null || ref1 === void 0 ? void 0 : ref1.date
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DefaultSectionCardRight, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                                            fontWeight: 700,
                                                            variant: "heading05",
                                                            children: event.attributes.title
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
                                                        variant: "paragraph02",
                                                        children: event.attributes.description
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                        href: "/events/".concat(event.attributes.url),
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MoreDetailButton, {
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                                                    fontWeight: 700,
                                                                    variant: "paragraph02",
                                                                    children: event.attributes.labelButton
                                                                }),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_icons/* IcoArrowRight */.ms, {
                                                                    width: "9.5px",
                                                                    height: "9px",
                                                                    style: {
                                                                        marginLeft: "7px"
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, i);
                                })
                            }),
                            checks && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Stack/* default */.Z, {
                                gap: 1,
                                children: checks.map((check, index)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
                                        direction: "row",
                                        gap: 1,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcoCheckBoldGreen, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                                sx: (theme)=>({
                                                        color: theme.palette.text.secondary
                                                    }),
                                                variant: "paragraph02",
                                                children: check.title
                                            })
                                        ]
                                    }, index))
                            }),
                            primaryButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: primaryButton.url,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                    size: "large",
                                    fullWidth: isMedium ? true : false,
                                    variant: "contained",
                                    color: "primary",
                                    children: primaryButton.label
                                })
                            }),
                            secondaryButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: secondaryButton.url,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                    size: "large",
                                    variant: "outlined",
                                    fullWidth: isMedium ? true : false,
                                    children: secondaryButton.label
                                })
                            }),
                            thirdButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: thirdButton.url,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button/* default */.Z, {
                                    size: "large",
                                    variant: "outlined",
                                    fullWidth: isMedium ? true : false,
                                    children: [
                                        thirdButton.label,
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_icons/* IcoShare */.Nh, {
                                            width: "24px",
                                            height: "24px"
                                        })
                                    ]
                                })
                            }),
                            forthButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: forthButton.url,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                    size: "large",
                                    variant: "contained",
                                    color: "primary",
                                    children: forthButton.label
                                })
                            }),
                            openNewTabButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: openNewTabButton.url,
                                rel: "noopener noreferrer",
                                target: "_blank",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button/* default */.Z, {
                                    size: "large",
                                    variant: "outlined",
                                    color: "primary",
                                    fullWidth: isMedium ? true : false,
                                    children: [
                                        openNewTabButton.label,
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_icons/* IcoShare */.Nh, {
                                            width: "24px",
                                            height: "24px"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })),
                (image || dateForEvent) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionRight, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, !isMedium ? {
                    order: inverted ? 0 : 1
                } : {
                    order: invertedMobile ? 0 : 1
                }), {
                    sx: (0,_object_spread/* default */.Z)({
                        justifyContent: !inverted ? "center" : "flex-start"
                    }, isMedium && {
                        justifyContent: "center"
                    }, isSmall && {
                        justifyContent: "center"
                    }),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                        sx: {
                            position: "relative",
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            maxWidth: imgMaxWidth ? imgMaxWidth : isHeroSection ? "564px" : "465px"
                        },
                        children: [
                            dateForEvent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(convertDatetoImage, {
                                date: dateForEvent,
                                isHeroSection: true
                            }),
                            image && !dateForEvent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_common_CustomImage/* default */.Z, {
                                src: "".concat(env/* default.API_BASE */.Z.API_BASE).concat(image.img.data[0].attributes.url, "?updatedAt=").concat(image.img.data[0].attributes.updatedAt),
                                alt: image.imgAlt || "",
                                width: image.img.data[0].attributes.width,
                                height: image.img.data[0].attributes.height
                            })
                        ]
                    })
                }))
            ]
        })
    });
};
/* harmony default export */ var DefaultSection_DefaultSection = (DefaultSection);

;// CONCATENATED MODULE: ./src/components/@common/DefaultSection/DefaultSection.style.ts


const Section = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$margin"
})((param)=>{
    let { theme , $margin  } = param;
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: theme.spacing(3),
        marginTop: [
            "both",
            "top"
        ].includes($margin) ? theme.spacing(15) : 0,
        marginBottom: [
            "both",
            "bottom"
        ].includes($margin) ? theme.spacing(15) : 0,
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            marginTop: [
                "both",
                "top"
            ].includes($margin) ? theme.spacing(6) : 0,
            marginBottom: [
                "both",
                "bottom"
            ].includes($margin) ? theme.spacing(6) : 0,
            gap: theme.spacing(4)
        }
    };
});
const SectionLeft = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$fullwidth"
})((param)=>{
    let { theme , $fullwidth  } = param;
    return {
        width: $fullwidth ? "100%" : "50%",
        gap: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        [theme.breakpoints.down("md")]: {
            width: "100%"
        }
    };
});
const SectionRight = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        width: "50%",
        display: "flex",
        alignItems: "center",
        position: "relative",
        [theme.breakpoints.down("md")]: {
            width: "100%"
        }
    };
});
const SectionTitle = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.neutral01[200],
        margin: 0
    };
});
const Description = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        maxWidth: "666px",
        color: theme.palette.text.secondary,
        [theme.breakpoints.down("sm")]: {
            maxWidth: "643px"
        }
    };
});
const DefaultSectionCards = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$columns"
})((param)=>{
    let { theme , $columns  } = param;
    return {
        width: "100%",
        display: "grid",
        gridTemplateColumns: "repeat(".concat($columns, ", 1fr)"),
        gap: theme.spacing(3),
        marginTop: theme.spacing(6),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr",
            marginTop: theme.spacing(2)
        }
    };
});
const DefaultSectionCard = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "grid",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "flex-start",
        borderRadius: theme.spacing(2),
        gridTemplateColumns: "1fr 9fr",
        gap: theme.spacing(3),
        border: "1px solid ".concat(theme.palette.neutral01[600]),
        padding: theme.spacing(3, 2),
        [theme.breakpoints.down("md")]: {
            margin: "0 auto",
            width: "100%"
        },
        "&:hover": {
            cursor: "pointer"
        }
    };
});
const ButtonsContainer = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "column",
        marginTop: theme.spacing(2),
        gap: theme.spacing(2),
        [theme.breakpoints.down("md")]: {
            gap: theme.spacing(1),
            margin: "0 auto",
            width: "100%"
        }
    };
});
const DefaultSectionCardRight = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "grid",
        flexDirection: "column",
        justifyContent: "space-between",
        borderRadius: theme.spacing(1)
    };
});
const Title = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: theme.spacing(1)
    };
});
const MoreDetailButton = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        color: theme.palette.primary.main,
        fill: theme.palette.primary.main,
        marginTop: theme.spacing(2),
        "&:hover": {
            color: theme.palette.global01[300],
            fill: theme.palette.global01[300],
            gap: theme.spacing(0.5)
        }
    };
});

;// CONCATENATED MODULE: ./src/components/@common/DefaultSection/index.ts



;// CONCATENATED MODULE: ./src/components/@common/InfoPages/InfoPages.style.ts


const InfoContent = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$margin"
})((param)=>{
    let { theme , $margin  } = param;
    return {
        maxWidth: 855,
        marginTop: [
            "both",
            "top"
        ].includes($margin) ? theme.spacing(15) : 0,
        marginBottom: [
            "both",
            "bottom"
        ].includes($margin) ? theme.spacing(15) : 0,
        [theme.breakpoints.down("md")]: {
            paddingBlock: theme.spacing(6)
        }
    };
});

;// CONCATENATED MODULE: ./src/components/@common/InfoPages/InfoPage.tsx




const InfoPage = (param)=>{
    let { content , margin ="both"  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InfoContent, {
            $margin: margin,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "paragraph01",
                children: content && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    dangerouslySetInnerHTML: {
                        __html: content
                    }
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/@common/OtherSaySection/OtherSaySection.style.ts


const OtherSaySection_style_Section = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$margin"
})((param)=>{
    let { theme , $margin  } = param;
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: theme.spacing(6),
        marginTop: [
            "both",
            "top"
        ].includes($margin) ? theme.spacing(15) : 0,
        marginBottom: [
            "both",
            "bottom"
        ].includes($margin) ? theme.spacing(15) : 0,
        paddingBottom: theme.spacing(15),
        paddingTop: theme.spacing(15),
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            marginTop: [
                "both",
                "top"
            ].includes($margin) ? theme.spacing(6) : 0,
            marginBottom: [
                "both",
                "bottom"
            ].includes($margin) ? theme.spacing(6) : 0,
            paddingBottom: theme.spacing(6),
            paddingTop: theme.spacing(6),
            gap: theme.spacing(4)
        }
    };
});
const SectionContent = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$margin"
})((param)=>{
    let { theme , $margin  } = param;
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: theme.spacing(1),
        marginTop: [
            "both",
            "top"
        ].includes($margin) ? theme.spacing(15) : 0,
        marginBottom: [
            "both",
            "bottom"
        ].includes($margin) ? theme.spacing(15) : 0,
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            marginTop: [
                "both",
                "top"
            ].includes($margin) ? theme.spacing(6) : 0,
            marginBottom: [
                "both",
                "bottom"
            ].includes($margin) ? theme.spacing(6) : 0,
            gap: theme.spacing(4)
        }
    };
});
const OtherSaySection_style_SectionLeft = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$fullwidth"
})((param)=>{
    let { theme , $fullwidth  } = param;
    return {
        width: $fullwidth ? "100%" : "50%",
        gap: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        [theme.breakpoints.down("md")]: {
            width: "100%"
        }
    };
});
const OtherSaySection_style_SectionRight = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        width: "50%",
        display: "flex",
        alignItems: "center",
        position: "relative",
        [theme.breakpoints.down("md")]: {
            width: "100%"
        }
    };
});
const OtherSaySection_style_SectionTitle = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.neutral01[200],
        margin: 0
    };
});
const OtherSaySection_style_Description = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        maxWidth: "466px",
        color: theme.palette.text.secondary,
        [theme.breakpoints.down("sm")]: {
            maxWidth: "343px"
        }
    };
});
const OtherSaySectionCards = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$columns"
})((param)=>{
    let { theme , $columns  } = param;
    return {
        width: "70%",
        display: "grid",
        gridTemplateColumns: "repeat(".concat($columns, ", 1fr)"),
        gap: theme.spacing(3),
        marginTop: theme.spacing(6),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr",
            width: "100%"
        }
    };
});
const OtherSaySectionCard = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "grid",
        alignItems: "space-evenly",
        borderRadius: theme.spacing(4),
        gridTemplateColumns: "3fr 17fr",
        gap: theme.spacing(3),
        padding: theme.spacing(3, 3),
        backgroundColor: theme.palette.neutral01[700],
        [theme.breakpoints.down("md")]: {
            margin: "0 auto",
            width: "100%",
            gridTemplateColumns: "1fr"
        }
    };
});
const OtherSaySection_style_ButtonsContainer = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "column",
        marginTop: theme.spacing(2),
        gap: theme.spacing(2),
        [theme.breakpoints.down("md")]: {
            gap: theme.spacing(1),
            margin: "0 auto",
            width: "100%"
        }
    };
});
const OtherSaySectionCardRight = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "grid",
        flexDirection: "column",
        justifyContent: "space-between",
        borderRadius: theme.spacing(1)
    };
});
const OtherSaySection_style_Title = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: theme.spacing(1)
    };
});

;// CONCATENATED MODULE: ./src/components/@common/OtherSaySection/OtherSaySection.tsx










const OtherSaySection = (param)=>{
    let { title , image , margin ="both" , headerSize ="small" , titleMaxWidth ="none" , isHeroSection =false , inverted =false , invertedMobile =false , otherSays  } = param;
    const { isSmall , isMedium  } = (0,useMedia/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        sx: {
            background: theme/* theme.palette.global01.700 */.r.palette.global01[700],
            minWidth: "100%"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OtherSaySection_style_Section, {
            component: "section",
            $margin: margin,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherSaySection_style_SectionTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    gutterBottom: true,
                    variant: headerSize === "large" ? "heading01" : "heading02"
                }, isHeroSection && {
                    component: "h1"
                }), {
                    maxWidth: titleMaxWidth,
                    children: title
                })),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SectionContent, {
                    $margin: "none",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherSaySection_style_SectionLeft, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, !isMedium ? {
                            order: inverted ? 1 : 0
                        } : {
                            order: invertedMobile ? 1 : 0
                        }), {
                            $fullwidth: false,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: otherSays && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherSaySectionCards, {
                                    $columns: 1,
                                    children: otherSays && otherSays.map((otherSay, i)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OtherSaySectionCard, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                                                    sx: {
                                                        position: "relative",
                                                        width: "100%",
                                                        height: "100%",
                                                        minWidth: "100px"
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomImage/* default */.Z, {
                                                        src: "".concat(env/* default.API_BASE */.Z.API_BASE).concat(otherSay.img.data.attributes.url, "?updatedAt=").concat(image.img.data[0].attributes.updatedAt),
                                                        alt: otherSay.imgAlt || "",
                                                        width: otherSay.img.data.attributes.width,
                                                        height: otherSay.img.data.attributes.height,
                                                        style: {
                                                            borderRadius: 10
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OtherSaySectionCardRight, {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                                            fontWeight: 400,
                                                            sx: {
                                                                color: theme/* theme.palette.neutral01.100 */.r.palette.neutral01[100]
                                                            },
                                                            variant: "paragraph01",
                                                            children: '" '.concat(otherSay.message, ' "')
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherSaySection_style_Description, {
                                                            variant: "paragraph01",
                                                            sx: {
                                                                color: theme/* theme.palette.neutral01.300 */.r.palette.neutral01[300]
                                                            },
                                                            children: "".concat(otherSay.fullName, " - ").concat(otherSay.onPosition)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, i))
                                })
                            })
                        })),
                        image && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OtherSaySection_style_SectionRight, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, !isMedium ? {
                            order: inverted ? 0 : 1
                        } : {
                            order: invertedMobile ? 0 : 1
                        }), {
                            sx: (0,_object_spread/* default */.Z)({
                                justifyContent: inverted ? "flex-end" : "flex-start"
                            }, isMedium && {
                                justifyContent: "center"
                            }, isSmall && {
                                justifyContent: "center"
                            }),
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                                sx: {
                                    position: "relative",
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    maxWidth: isHeroSection ? "564px" : "465px"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomImage/* default */.Z, {
                                    src: "".concat(env/* default.API_BASE */.Z.API_BASE).concat(image.img.data[0].attributes.url, "?updatedAt=").concat(image.img.data[0].attributes.updatedAt),
                                    alt: image.imgAlt || "",
                                    width: image.img.data[0].attributes.width,
                                    height: image.img.data[0].attributes.height
                                })
                            })
                        }))
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var OtherSaySection_OtherSaySection = (OtherSaySection);

;// CONCATENATED MODULE: ./src/components/@common/ProvisionSection/ProvisionSection.style.ts


const ProvisionSection_style_Section = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$margin"
})((param)=>{
    let { theme , $margin  } = param;
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "top",
        gap: theme.spacing(2),
        marginTop: [
            "both",
            "top"
        ].includes($margin) ? theme.spacing(15) : 0,
        marginBottom: [
            "both",
            "bottom"
        ].includes($margin) ? theme.spacing(15) : 0,
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            marginTop: [
                "both",
                "top"
            ].includes($margin) ? theme.spacing(6) : 0,
            marginBottom: [
                "both",
                "bottom"
            ].includes($margin) ? theme.spacing(6) : 0,
            gap: theme.spacing(4)
        }
    };
});
const ProvisionSection_style_SectionLeft = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$fullwidth"
})((param)=>{
    let { theme , $fullwidth  } = param;
    return {
        width: $fullwidth ? "100%" : "20%",
        gap: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        alignItems: "top",
        [theme.breakpoints.down("md")]: {
            width: "100%"
        }
    };
});
const ProvisionSection_style_SectionRight = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        display: "flex",
        alignItems: "center",
        position: "relative",
        marginTop: theme.spacing(6),
        [theme.breakpoints.down("md")]: {
            width: "100%"
        }
    };
});
const ProvisionSection_style_SectionTitle = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.neutral01[200],
        margin: 0,
        marginBottom: theme.spacing(2)
    };
});
const ProvisionSection_style_Description = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        maxWidth: "576px",
        color: theme.palette.text.secondary,
        [theme.breakpoints.down("sm")]: {
            maxWidth: "343px"
        }
    };
});
const VerkoopSectionCards = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$columns"
})((param)=>{
    let { theme , $columns  } = param;
    return {
        width: "100%",
        display: "grid",
        gridTemplateColumns: "repeat(".concat($columns, ", 1fr)"),
        gap: theme.spacing(1),
        marginTop: theme.spacing(6),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr"
        }
    };
});
const VerkoopSectionCard = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "grid",
        flexDirection: "column",
        borderRadius: theme.spacing(2),
        gap: theme.spacing(1),
        padding: theme.spacing(3, 3),
        backgroundColor: theme.palette.global01[700],
        [theme.breakpoints.down("md")]: {
            margin: "0 auto",
            width: "100%"
        }
    };
});
const ProvisionSection_style_ButtonsContainer = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "column",
        marginTop: theme.spacing(2),
        gap: theme.spacing(2),
        [theme.breakpoints.down("md")]: {
            gap: theme.spacing(1),
            margin: "0 auto",
            width: "100%"
        }
    };
});
const ProvisionSection_style_Title = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: theme.spacing(1)
    };
});

;// CONCATENATED MODULE: ./src/components/@common/ProvisionSection/ProvisionSection.tsx











const Provision = (param)=>{
    let { icon , tagline , title , description , checks , primaryButton , secondaryButton , thirdButton , forthButton , openNewTabButton , img , margin ="both" , headerSize ="small" , titleMaxWidth ="none" , isHeroSection =false , inverted =false , invertedMobile =false , provision  } = param;
    const { isSmall , isMedium  } = (0,useMedia/* default */.Z)();
    const IcoCheckBoldGreen = (0,styled/* default */.ZP)(_icons/* IcoCheckBold */.zM)((param)=>{
        let { theme  } = param;
        return {
            color: theme.palette.success.main,
            minWidth: "24px",
            minHeight: "24px"
        };
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProvisionSection_style_Section, {
            component: "section",
            $margin: margin,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProvisionSection_style_SectionLeft, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, !isMedium ? {
                    order: inverted ? 1 : 0
                } : {
                    order: invertedMobile ? 1 : 0
                }), {
                    $fullwidth: !img,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            tagline && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
                                direction: "row",
                                gap: 1,
                                sx: (theme)=>({
                                        color: theme.palette.neutral01[400],
                                        fill: theme.palette.neutral01[400]
                                    }),
                                children: [
                                    icon && /*#__PURE__*/ react.cloneElement(icon, {
                                        style: {
                                            width: "32px",
                                            height: "32px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                        variant: "heading04",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            id: tagline
                                        })
                                    })
                                ]
                            }),
                            provision && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerkoopSectionCards, {
                                $columns: 1,
                                children: provision && provision.map((provisionItem, i)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VerkoopSectionCard, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProvisionSection_style_Title, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                                    fontWeight: 700,
                                                    variant: "heading05",
                                                    children: provisionItem.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProvisionSection_style_Description, {
                                                variant: "paragraph01",
                                                children: provisionItem.description
                                            })
                                        ]
                                    }, i))
                            }),
                            checks && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Stack/* default */.Z, {
                                gap: 1,
                                children: checks.map((check, index)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
                                        direction: "row",
                                        gap: 1,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcoCheckBoldGreen, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                                sx: (theme)=>({
                                                        color: theme.palette.text.secondary
                                                    }),
                                                variant: "paragraph02",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    id: check
                                                })
                                            })
                                        ]
                                    }, index))
                            })
                        ]
                    })
                })),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProvisionSection_style_SectionRight, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, !isMedium ? {
                    order: inverted ? 0 : 1
                } : {
                    order: invertedMobile ? 0 : 1
                }), {
                    sx: (0,_object_spread/* default */.Z)({
                        justifyContent: !inverted ? "flex-end" : "flex-start"
                    }, isMedium && {
                        justifyContent: "center"
                    }, isSmall && {
                        justifyContent: "center"
                    }),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                        sx: {
                            position: "relative",
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "left",
                            alignItems: "left"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProvisionSection_style_SectionTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                gutterBottom: true,
                                variant: tagline || headerSize === "large" ? "heading01" : "heading02"
                            }, isHeroSection && {
                                component: "h1"
                            }), {
                                maxWidth: titleMaxWidth,
                                children: title
                            })),
                            description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProvisionSection_style_Description, {
                                variant: "paragraph01",
                                children: description
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                                children: [
                                    primaryButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        href: primaryButton.url,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                            size: "large",
                                            sx: {
                                                mt: theme/* theme.spacing */.r.spacing(2)
                                            },
                                            fullWidth: isMedium ? true : false,
                                            children: primaryButton.label
                                        })
                                    }),
                                    secondaryButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        href: secondaryButton.url,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                            size: "large",
                                            variant: "outlined",
                                            fullWidth: isMedium ? true : false,
                                            children: secondaryButton.label
                                        })
                                    }),
                                    thirdButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        href: thirdButton.url,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button/* default */.Z, {
                                            size: "large",
                                            variant: "outlined",
                                            fullWidth: isMedium ? true : false,
                                            children: [
                                                thirdButton.label,
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_icons/* IcoShare */.Nh, {
                                                    width: "24px",
                                                    height: "24px"
                                                })
                                            ]
                                        })
                                    }),
                                    forthButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        href: forthButton.url,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                            size: "large",
                                            variant: "contained",
                                            color: "primary",
                                            children: forthButton.label
                                        })
                                    }),
                                    openNewTabButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        href: openNewTabButton.url,
                                        rel: "noopener noreferrer",
                                        target: "_blank",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button/* default */.Z, {
                                            size: "large",
                                            variant: "outlined",
                                            color: "primary",
                                            children: [
                                                openNewTabButton.label,
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_icons/* IcoShare */.Nh, {
                                                    width: "24px",
                                                    height: "24px"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }))
            ]
        })
    });
};
/* harmony default export */ var ProvisionSection = (Provision);

// EXTERNAL MODULE: ./node_modules/@mui/material/Pagination/Pagination.js + 7 modules
var Pagination = __webpack_require__(6082);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(6896);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./src/redux/slices/eventsSlice.ts
var eventsSlice = __webpack_require__(4767);
;// CONCATENATED MODULE: ./src/hooks/useSearchDebounce.ts

const useSearchDebounce = (searchTerm, delay)=>{
    const { 0: searchResults , 1: setSearchResults  } = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        const timerId = setTimeout(()=>{
            // Split the search term into an array of words
            const words = searchTerm.trim().split(" ");
            setSearchResults(words);
        }, delay);
        return ()=>{
            clearTimeout(timerId);
        };
    }, [
        searchTerm,
        delay
    ]);
    return searchResults;
};
/* harmony default export */ var hooks_useSearchDebounce = (useSearchDebounce);

// EXTERNAL MODULE: ./src/components/@common/TextField/index.ts + 7 modules
var TextField = __webpack_require__(8623);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var styles_makeStyles = __webpack_require__(1120);
;// CONCATENATED MODULE: ./src/components/@common/SeacrchEventSection/SeacrchEventSection.style.ts


const SearchInputSection = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        marginTop: theme.spacing(1),
        display: "grid",
        gap: theme.spacing(1),
        gridTemplateColumns: "5fr 2fr",
        flexDirection: "row",
        width: "100%",
        [theme.breakpoints.down("md")]: {
            display: "grid",
            flexDirection: "column",
            gridTemplateColumns: "5fr ",
            width: "100%"
        }
    };
});
const EventSectionCards = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$columns"
})((param)=>{
    let { theme , $columns  } = param;
    return {
        width: "100%",
        display: "grid",
        gridTemplateColumns: "repeat(".concat($columns, ", 1fr)"),
        gap: theme.spacing(2),
        marginTop: theme.spacing(6),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr",
            marginTop: theme.spacing(2)
        }
    };
});
const EventSectionCard = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "grid",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "flex-start",
        borderRadius: theme.spacing(2),
        gridTemplateColumns: "1fr 9fr",
        gap: theme.spacing(3),
        border: "1px solid ".concat(theme.palette.neutral01[600]),
        padding: theme.spacing(3, 2),
        [theme.breakpoints.down("md")]: {
            margin: "0 auto",
            width: "100%"
        },
        "&:hover": {
            cursor: "pointer"
        }
    };
});
const EventSectionCardRight = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "grid",
        flexDirection: "column",
        justifyContent: "space-between",
        borderRadius: theme.spacing(1)
    };
// position: 'relative',
});
const SeacrchEventSection_style_Description = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        maxWidth: "666px",
        color: theme.palette.text.secondary,
        [theme.breakpoints.down("sm")]: {
            maxWidth: "643px"
        }
    };
});
const SeacrchEventSection_style_Title = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: theme.spacing(1)
    };
});
const SeacrchEventSection_style_MoreDetailButton = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        color: theme.palette.primary.main,
        fill: theme.palette.primary.main,
        "&:hover": {
            color: theme.palette.global01[300],
            fill: theme.palette.global01[300],
            gap: theme.spacing(0.5)
        }
    };
});

;// CONCATENATED MODULE: ./src/components/@common/SeacrchEventSection/HighlightedText.tsx






const HighlightedText_useStyles = (0,styles_makeStyles/* default */.Z)(()=>({
        highlighted: {
            backgroundColor: theme/* theme.palette.global01.700 */.r.palette.global01[700],
            color: theme/* theme.palette.global01.400 */.r.palette.global01[400]
        }
    }));
const HighlightedText = (param)=>{
    let { originalText , searchTerm , type ="desc" ,  } = param;
    const classes = HighlightedText_useStyles();
    const getHighlightedText = ()=>{
        if (!searchTerm.length || searchTerm.some((term)=>term.trim() === "")) {
            return originalText;
        }
        const regex = new RegExp("(".concat(searchTerm.join("|"), ")"), "gi");
        const parts = originalText.split(regex);
        return parts.map((part, index)=>regex.test(part) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("mark", {
                className: classes.highlighted,
                children: part
            }, index) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {
                children: part
            }, index));
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            type === "title" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeacrchEventSection_style_Title, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                    fontWeight: 700,
                    variant: "heading05",
                    children: getHighlightedText()
                })
            }),
            type === "desc" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeacrchEventSection_style_Title, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeacrchEventSection_style_Description, {
                    variant: "paragraph02",
                    children: getHighlightedText()
                })
            })
        ]
    });
};
/* harmony default export */ var SeacrchEventSection_HighlightedText = (HighlightedText);

;// CONCATENATED MODULE: ./src/components/@common/SeacrchEventSection/SeacrchEventSection.tsx



















const SeacrchEventSection = (param)=>{
    let { title , labelButton  } = param;
    const router = (0,next_router.useRouter)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const dispatch = (0,es/* useDispatch */.I0)();
    const intl = (0,useIntl/* default */.Z)();
    const { locale  } = (0,useLocale/* useLocale */.b)();
    const { isMedium  } = (0,useMedia/* default */.Z)();
    const events = (0,es/* useSelector */.v9)((state)=>state.eventStore.events);
    const eventsCriteria = (0,es/* useSelector */.v9)((state)=>state.eventStore);
    const { 0: searchTerm , 1: setSearchTerm  } = (0,react.useState)("");
    const searchDebounce = hooks_useSearchDebounce(searchTerm, 1000);
    (0,react.useEffect)(()=>{
        if (locale && eventsCriteria.meta.pagination.page) {
            loadData(localConvert/* languageCodeMap */.B[locale]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        locale,
        eventsCriteria.meta.pagination.page,
        eventsCriteria.searchText,
        searchDebounce
    ]);
    const loadData = async (locale)=>{
        let getEventQuery = {
            locale: locale,
            pagination: {
                page: eventsCriteria.meta.pagination.page,
                pageSize: 6
            },
            sort: {
                date: "ASC"
            },
            filters: {
                $or: [
                    {
                        description: {
                            $contains: searchDebounce
                        }
                    },
                    {
                        title: {
                            $contains: searchDebounce
                        }
                    }, 
                ]
            }
        };
        dispatch((0,eventsSlice/* getEventsByCriteria */.vM)(lib_default().stringify(getEventQuery, {
            encodeValuesOnly: true
        })));
    };
    const handleSearchChange = (search)=>{
        setSearchTerm(search);
    };
    const handChangePage = (_, page)=>{
        dispatch((0,eventsSlice/* changePage */.oO)(page));
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.Z, {
        sx: {
            marginY: theme/* theme.spacing */.r.spacing(15)
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                sx: {
                    width: {
                        sm: "100%",
                        md: "50%",
                        lg: "60%"
                    },
                    marginBottom: theme/* theme.spacing */.r.spacing(1)
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                        variant: "heading04",
                        component: "h3",
                        children: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SearchInputSection, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextField/* TextField */.n, {
                                value: searchTerm,
                                handleChange: handleSearchChange,
                                label: ""
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                fullWidth: isMedium ? true : false,
                                variant: "contained",
                                color: "primary",
                                children: labelButton
                            })
                        ]
                    })
                ]
            }),
            eventsCriteria && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                variant: "paragraph02",
                component: "h3",
                sx: {
                    color: theme/* theme.palette.neutral01.300 */.r.palette.neutral01[300]
                },
                children: "".concat(intl.formatMessage({
                    id: "common.searchEvent.found"
                }), " ").concat(eventsCriteria.meta.pagination.total, " ").concat(intl.formatMessage({
                    id: "common.searchEvent.results"
                }))
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                sx: {
                    marginY: theme/* theme.spacing */.r.spacing(3)
                },
                children: [
                    " ",
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EventSectionCards, {
                        $columns: 2,
                        children: events && events.map((event, i)=>{
                            var ref, ref1;
                            /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EventSectionCard, {
                                onClick: ()=>router.push("/events/".concat(event.attributes.url)),
                                children: [
                                    ((ref = event.attributes) === null || ref === void 0 ? void 0 : ref.date) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(convertDatetoImage, {
                                        date: (ref1 = event.attributes) === null || ref1 === void 0 ? void 0 : ref1.date
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EventSectionCardRight, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                                                sx: {
                                                    minHeight: "170px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeacrchEventSection_HighlightedText, {
                                                        originalText: event.attributes.title,
                                                        type: "title",
                                                        searchTerm: searchDebounce
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeacrchEventSection_HighlightedText, {
                                                        originalText: event.attributes.description,
                                                        type: "desc",
                                                        searchTerm: searchDebounce
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                href: "/events/".concat(event.attributes.url),
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SeacrchEventSection_style_MoreDetailButton, {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                                            fontWeight: 700,
                                                            variant: "paragraph02",
                                                            children: event.attributes.labelButton
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_icons/* IcoArrowRight */.ms, {
                                                            width: "9.5px",
                                                            height: "9px",
                                                            style: {
                                                                marginLeft: "7px"
                                                            }
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                        sx: {
                            marginTop: theme/* theme.spacing */.r.spacing(3),
                            display: "grid",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pagination/* default */.Z, {
                            count: eventsCriteria.meta.pagination.pageCount,
                            variant: "outlined",
                            shape: "rounded",
                            page: eventsCriteria.meta.pagination.page,
                            onChange: (_, page)=>handChangePage(_, page)
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var SeacrchEventSection_SeacrchEventSection = (SeacrchEventSection);

;// CONCATENATED MODULE: ./src/components/@common/ServiceSection/ServiceSection.style.ts


const ServiceSection_style_Section = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$margin"
})((param)=>{
    let { theme , $margin  } = param;
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "top",
        gap: theme.spacing(4),
        marginTop: [
            "both",
            "top"
        ].includes($margin) ? theme.spacing(15) : 0,
        marginBottom: [
            "both",
            "bottom"
        ].includes($margin) ? theme.spacing(15) : 0,
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            marginTop: [
                "both",
                "top"
            ].includes($margin) ? theme.spacing(6) : 0,
            marginBottom: [
                "both",
                "bottom"
            ].includes($margin) ? theme.spacing(6) : 0,
            gap: theme.spacing(4),
            padding: 0
        },
        [theme.breakpoints.down("lg")]: {
            padding: 0,
            gap: theme.spacing(4)
        }
    };
});
const ServiceSection_style_SectionLeft = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$fullwidth"
})((param)=>{
    let { theme , $fullwidth  } = param;
    return {
        width: $fullwidth ? "100%" : "40%",
        gap: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        marginTop: theme.spacing(15),
        [theme.breakpoints.down("md")]: {
            width: "100%",
            marginTop: theme.spacing(6)
        }
    };
});
const ServiceSection_style_SectionRight = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        width: "60%",
        display: "flex",
        alignItems: "center",
        position: "relative",
        [theme.breakpoints.down("md")]: {
            width: "100%"
        }
    };
});
const ServiceSection_style_SectionTitle = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.neutral01["700"],
        margin: 0
    };
});
const ServiceSection_style_Description = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        maxWidth: "446px",
        color: theme.palette.global01["600"],
        [theme.breakpoints.down("sm")]: {
            maxWidth: "643px"
        }
    };
});
const ServiceSectionCards = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$columns"
})((param)=>{
    let { theme , $columns  } = param;
    return {
        width: "100%",
        display: "grid",
        gridTemplateColumns: "repeat(".concat($columns, ", 1fr)"),
        gap: theme.spacing(3),
        marginTop: theme.spacing(15),
        marginBottom: theme.spacing(15),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr",
            marginTop: theme.spacing(3),
            marginBottom: theme.spacing(6)
        }
    };
});
const ServiceSectionCard = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "grid",
        flexDirection: "column",
        justifyContent: "space-between",
        borderRadius: theme.spacing(2),
        // gridTemplateColumns: `2fr 7fr`,
        gridTemplateColumns: "2fr 7fr",
        gap: theme.spacing(3),
        border: "1px solid ".concat(theme.palette.neutral01[600]),
        padding: theme.spacing(2, 2),
        backgroundColor: theme.palette.background.paper,
        [theme.breakpoints.down("md")]: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: theme.spacing(3)
        },
        "&:hover": {
            cursor: "pointer"
        }
    };
});
const ServiceSectionCardRight = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "grid",
        flexDirection: "column",
        justifyContent: "space-between",
        borderRadius: theme.spacing(1)
    };
});
const ServiceSection_style_Title = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: theme.spacing(1)
    };
});
const DescriptionServiceCard = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        maxWidth: "466px",
        color: theme.palette.neutral01["300"],
        [theme.breakpoints.down("sm")]: {
            maxWidth: "466px"
        }
    };
});
const ServiceSection_style_MoreDetailButton = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        color: theme.palette.primary.main,
        fill: theme.palette.primary.main,
        marginTop: theme.spacing(2),
        "&:hover": {
            color: theme.palette.global01[300],
            fill: theme.palette.global01[300],
            gap: theme.spacing(0.5)
        }
    };
});

;// CONCATENATED MODULE: ./src/components/@common/ServiceSection/index.ts



;// CONCATENATED MODULE: ./src/components/@common/ServiceSection/ServiceSection.tsx


















const ServiceSection = (param)=>{
    let { tagline , title , description , margin ="both" , headerSize ="small" , titleMaxWidth ="none" , isHeroSection =false , inverted =false , invertedMobile =false  } = param;
    const { isSmall , isMedium  } = (0,useMedia/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const { locale  } = (0,useLocale/* useLocale */.b)();
    const { serviceSlug  } = router.query;
    const { 0: services , 1: setServices  } = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        if (locale) {
            loadData(serviceSlug, localConvert/* languageCodeMap */.B[locale]);
        }
    }, [
        locale,
        serviceSlug
    ]);
    const loadData = async (serviceSlug, locale)=>{
        try {
            let getServiceBySlugQuery;
            if (serviceSlug) {
                getServiceBySlugQuery = {
                    populate: "deep",
                    locale: locale,
                    filters: {
                        url: {
                            $ne: "".concat(serviceSlug)
                        }
                    }
                };
            } else {
                getServiceBySlugQuery = {
                    populate: "deep",
                    locale: locale
                };
            }
            const response = await api/* ServicesService.getAllServices */.rm.getAllServices(lib_default().stringify(getServiceBySlugQuery, {
                encodeValuesOnly: true
            }));
            if (response && (response === null || response === void 0 ? void 0 : response.data)) {
                setServices(response === null || response === void 0 ? void 0 : response.data);
            } else {
                // router.push('/404');
                setServices([]);
            }
        } catch (error) {
            esm_exports/* captureException */.Tb(error);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        sx: {
            background: theme/* theme.palette.global01.100 */.r.palette.global01[100],
            minWidth: "100%",
            padding: 0
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ServiceSection_style_Section, {
                component: "section",
                $margin: margin,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServiceSection_style_SectionLeft, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, !isMedium ? {
                        order: inverted ? 1 : 0
                    } : {
                        order: invertedMobile ? 1 : 0
                    }), {
                        $fullwidth: false,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServiceSection_style_SectionTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    gutterBottom: true,
                                    variant: tagline || headerSize === "large" ? "heading01" : "heading03"
                                }, isHeroSection && {
                                    component: "h1"
                                }), {
                                    maxWidth: titleMaxWidth,
                                    children: title
                                })),
                                description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServiceSection_style_Description, {
                                    variant: "paragraph01",
                                    sx: {
                                        color: theme/* theme.palette.global01.600 */.r.palette.global01[600]
                                    },
                                    children: description
                                })
                            ]
                        })
                    })),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServiceSection_style_SectionRight, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, !isMedium ? {
                        order: inverted ? 0 : 1
                    } : {
                        order: invertedMobile ? 0 : 1
                    }), {
                        sx: (0,_object_spread/* default */.Z)({
                            justifyContent: !inverted ? "flex-end" : "flex-start"
                        }, isMedium && {
                            justifyContent: "center"
                        }, isSmall && {
                            justifyContent: "center"
                        }),
                        children: services && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServiceSectionCards, {
                            $columns: 1,
                            children: services && services.map((service, i)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ServiceSectionCard, {
                                    onClick: ()=>router.push("/services/".concat(service.attributes.url)),
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                                            sx: {
                                                position: "relative",
                                                width: "100%",
                                                height: "100%",
                                                maxWidth: "155px"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_common_CustomImage/* default */.Z, {
                                                src: "".concat(env/* default.API_BASE */.Z.API_BASE).concat(service.attributes.image.img.data[0].attributes.url, "?updatedAt=").concat(service.attributes.image.img.data[0].attributes.updatedAt),
                                                alt: service.attributes.image.imgAlt || "",
                                                width: service.attributes.image.img.data[0].attributes.width,
                                                height: service.attributes.image.img.data[0].attributes.height
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ServiceSectionCardRight, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ServiceSection_style_Title, {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                                        fontWeight: 700,
                                                        variant: "heading04",
                                                        children: service.attributes.title
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionServiceCard, {
                                                    variant: "paragraph01",
                                                    children: service.attributes.description
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                    href: "/services/".concat(service.attributes.url),
                                                    style: {
                                                        display: "flex",
                                                        justifyContent: "flex-start",
                                                        alignItems: "center"
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ServiceSection_style_MoreDetailButton, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                                                fontWeight: 700,
                                                                variant: "paragraph02",
                                                                children: service.attributes.labelButton
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_icons/* IcoArrowRight */.ms, {
                                                                style: {
                                                                    width: "9.5px",
                                                                    height: "9px",
                                                                    marginLeft: "7px"
                                                                }
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, i))
                        })
                    }))
                ]
            })
        })
    });
};
/* harmony default export */ var ServiceSection_ServiceSection = (ServiceSection);

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(6501);
// EXTERNAL MODULE: ./src/utils/regexUtils.ts
var regexUtils = __webpack_require__(9832);
// EXTERNAL MODULE: ./src/components/@common/index.ts + 2 modules
var _common = __webpack_require__(6517);
;// CONCATENATED MODULE: ./src/components/@common/Support/Support.style.ts


const SupportContainer = (0,styled/* default */.ZP)(Container/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "grid",
        // backgroundColor: theme.palette.global01[700],
        // borderTop: '1px solid ',
        // borderColor: theme.palette.global01[300],
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: theme.spacing(3),
        paddingBlock: theme.spacing(3),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr",
            gap: theme.spacing(3)
        }
    };
});
const SupportSectionLeft = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let {} = param;
    return {
        display: "flex",
        alignItems: "center",
        margin: 0,
        padding: 0
    };
});
const SupportSectionRight = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        justifyContent: "center",
        gap: theme.spacing(2),
        [theme.breakpoints.down("md")]: {
            display: "grid",
            gridTemplateColumns: "1fr"
        }
    };
});
const Support_style_Title = (0,styled/* default */.ZP)(Typography/* default */.Z)(()=>({
        variant: "heading05",
        fontWeight: "bold"
    }));
const Support_style_Description = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.neutral01[300]
    };
});
Support_style_Description.defaultProps = {
    variant: "paragraph01"
};

;// CONCATENATED MODULE: ./src/components/@common/Support/Support.tsx


















const Support = (param)=>{
    let { title , labelButton  } = param;
    const { locale  } = (0,useLocale/* useLocale */.b)();
    const intl = (0,useIntl/* default */.Z)();
    const { handleSubmit , control , formState: { errors  } ,  } = (0,index_esm/* useForm */.cI)();
    const onSubmitForm = handleSubmit((data)=>{
        const dataForSubmit = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
            locale: localConvert/* languageCodeMap */.B[locale]
        });
        dist/* toast.loading */.Am.loading(intl.formatMessage({
            id: "common.notification.loading"
        }));
        handleSubmitForm(dataForSubmit);
    });
    const handleSubmitForm = async (data)=>{
        try {
            const response = await api/* EmailRegisteredService.createNewEntry */.n5.createNewEntry(data);
            if (response && (response === null || response === void 0 ? void 0 : response.data)) {
                dist/* toast.dismiss */.Am.dismiss();
                dist/* toast.success */.Am.success(intl.formatMessage({
                    id: "common.notification.success"
                }));
            }
        } catch (error) {
            esm_exports/* captureException */.Tb(error);
            dist/* toast.error */.Am.error(intl.formatMessage({
                id: "common.notification.error"
            }));
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        sx: {
            background: theme/* theme.palette.global01.100 */.r.palette.global01[100],
            minWidth: "100%",
            borderTop: "1px solid ",
            borderColor: theme/* theme.palette.global01.300 */.r.palette.global01[300],
            padding: 0
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SupportContainer, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SupportSectionLeft, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                            sx: {
                                borderRadius: 100,
                                minWidth: theme/* theme.spacing */.r.spacing(6),
                                minHeight: theme/* theme.spacing */.r.spacing(6),
                                backgroundColor: theme/* theme.palette.global01.300 */.r.palette.global01[300],
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginRight: theme/* theme.spacing */.r.spacing(2)
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_icons/* IcoMail */.aV, {
                                width: "36px",
                                height: "32px",
                                fill: theme/* theme.palette.background.paper */.r.palette.background.paper
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                variant: "heading05",
                                color: theme/* theme.palette.background.paper */.r.palette.background.paper,
                                children: title
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SupportSectionRight, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Controller */.Qr, {
                            name: "email",
                            control: control,
                            defaultValue: "",
                            rules: {
                                required: true,
                                pattern: {
                                    value: regexUtils/* regexEmail */.Ej,
                                    message: "Error"
                                }
                            },
                            render: (param)=>{
                                let { field  } = param;
                                var ref;
                                /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_common/* TextField */.nv, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                                    value: field.value || "",
                                    flex: 1,
                                    hasError: errors.email ? true : false,
                                    errorMessage: (errors === null || errors === void 0 ? void 0 : (ref = errors.email) === null || ref === void 0 ? void 0 : ref.type) == "required" ? "contactForm.error.required" : "contactForm.error.pattern",
                                    placeholder: intl.formatMessage({
                                        id: "common.email.placeholder"
                                    }),
                                    handleChange: (value)=>field.onChange(value)
                                }));
                            }
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: "support.description",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                size: "medium",
                                sx: {
                                    width: "100%"
                                },
                                variant: "contained",
                                color: "primary",
                                onClick: onSubmitForm,
                                children: labelButton
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Support_Support = (Support);

;// CONCATENATED MODULE: ./src/components/@common/TeamSection/TeamSection.style.ts


const TeamSection_style_Section = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$margin"
})((param)=>{
    let { theme , $margin  } = param;
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: theme.spacing(1),
        paddingBlock: theme.spacing(15),
        marginTop: [
            "both",
            "top"
        ].includes($margin) ? theme.spacing(15) : 0,
        marginBottom: [
            "both",
            "bottom"
        ].includes($margin) ? theme.spacing(15) : 0,
        [theme.breakpoints.down("lg")]: {
            paddingBlock: theme.spacing(15),
            gap: theme.spacing(4)
        },
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            marginTop: [
                "both",
                "top"
            ].includes($margin) ? theme.spacing(6) : 0,
            marginBottom: [
                "both",
                "bottom"
            ].includes($margin) ? theme.spacing(6) : 0,
            gap: theme.spacing(4),
            paddingBlock: theme.spacing(15)
        },
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
            marginTop: [
                "both",
                "top"
            ].includes($margin) ? theme.spacing(6) : 0,
            marginBottom: [
                "both",
                "bottom"
            ].includes($margin) ? theme.spacing(6) : 0,
            gap: theme.spacing(4),
            paddingBlock: theme.spacing(6)
        },
        [theme.breakpoints.down("xs")]: {
            flexDirection: "column",
            marginTop: [
                "both",
                "top"
            ].includes($margin) ? theme.spacing(6) : 0,
            marginBottom: [
                "both",
                "bottom"
            ].includes($margin) ? theme.spacing(6) : 0,
            gap: theme.spacing(4),
            paddingBlock: theme.spacing(6)
        }
    };
});
const TeamSection_style_SectionTitle = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.neutral01["700"],
        margin: 0
    };
});
const TeamSection_style_Description = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        maxWidth: "606px",
        textAlign: "center",
        color: theme.palette.global01["600"],
        [theme.breakpoints.down("sm")]: {
            maxWidth: "343px"
        }
    };
});
const TeamSectionCards = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$columns"
})((param)=>{
    let { theme , $columns  } = param;
    return {
        width: "100%",
        display: "grid",
        gridTemplateColumns: "repeat(".concat($columns, ", 1fr)"),
        marginTop: theme.spacing(2),
        padding: theme.spacing(0, 6),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "repeat(".concat($columns, ", 1fr)"),
            padding: theme.spacing(0)
        }
    };
});
const TeamSectionCard = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "grid",
        flexDirection: "column",
        justifyContent: "space-between",
        borderRadius: theme.spacing(1),
        gridTemplateColumns: "2fr 7fr",
        gap: theme.spacing(2),
        padding: theme.spacing(2, 2),
        alignItems: "top",
        height: "fit-content",
        [theme.breakpoints.down("md")]: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: theme.spacing(1, 1),
            gap: theme.spacing(0),
            gridTemplateColumns: "repeat(1fr)"
        },
        [theme.breakpoints.down("sm")]: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: theme.spacing(1, 0.5),
            gap: theme.spacing(0),
            gridTemplateColumns: "repeat(1fr)"
        }
    };
});
const TeamSectionCardRight = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "grid",
        flexDirection: "column",
        justifyContent: "space-between",
        gap: theme.spacing(0),
        borderRadius: theme.spacing(1)
    };
});
const TeamSection_style_Title = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "top",
        flexWrap: "wrap",
        width: "9rem",
        color: theme.palette.background.paper,
        [theme.breakpoints.down("xs")]: {
            maxWidth: "103px"
        }
    };
});
const TeamSection_style_DescriptionServiceCard = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        maxWidth: "466px",
        width: "9rem",
        display: "flex",
        flexDirection: "row",
        alignItems: "top",
        flexWrap: "wrap",
        color: theme.palette.neutral01["500"],
        [theme.breakpoints.down("sm")]: {
            maxWidth: "343px"
        }
    };
});

;// CONCATENATED MODULE: ./src/components/@common/TeamSection/index.ts



;// CONCATENATED MODULE: ./src/components/@common/TeamSection/TeamSection.tsx










const TeamSection = (param)=>{
    let { title , description , margin ="both" , headerSize ="small" , isHeroSection =false , teams  } = param;
    const { isSmall  } = (0,useMedia/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        sx: {
            background: theme/* theme.palette.global01.100 */.r.palette.global01[100],
            minWidth: "100%"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TeamSection_style_Section, {
                component: "section",
                $margin: margin,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TeamSection_style_SectionTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        gutterBottom: true,
                        variant: headerSize === "large" ? "heading01" : "heading02"
                    }, isHeroSection && {
                        component: "h1"
                    }), {
                        children: title
                    })),
                    description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TeamSection_style_Description, {
                        variant: "paragraph01",
                        children: description
                    }),
                    teams && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TeamSectionCards, {
                        $columns: 2,
                        children: teams && Array.isArray(teams) && teams.map((team, i)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TeamSectionCard, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                                        sx: {
                                            width: "105px",
                                            height: "105px",
                                            maxWidth: {
                                                lg: "100px",
                                                md: "163px",
                                                sm: "163px",
                                                xs: "100px"
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_common_CustomImage/* default */.Z, {
                                            src: "".concat(env/* default.API_BASE */.Z.API_BASE).concat(team.img.data.attributes.url, "?updatedAt=").concat(team.img.data.attributes.updatedAt),
                                            alt: team.imgAlt || "",
                                            width: "105px",
                                            height: "105px",
                                            style: {
                                                borderRadius: theme/* theme.spacing */.r.spacing(1)
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TeamSectionCardRight, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TeamSection_style_Title, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                                    fontWeight: 700,
                                                    variant: isSmall ? "paragraph02" : "heading05",
                                                    children: team.fullName
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TeamSection_style_DescriptionServiceCard, {
                                                style: {
                                                    width: "8rem"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Typography/* default */.Z, {
                                                    variant: isSmall ? "caption01" : "paragraph02",
                                                    children: [
                                                        " ",
                                                        team.onPosition
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }, i))
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var TeamSection_TeamSection = (TeamSection);

;// CONCATENATED MODULE: ./src/components/@common/trustedOrganizations/TrustedOrganizations.tsx





const TrustedOrganizations = (param)=>{
    let { trustedOrganizations , title  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrustedContainer, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustedOrganizations_style_Title, {
                    align: "center",
                    variant: "heading05",
                    fontWeight: "800",
                    children: title && title
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustedLogos, {
                    children: trustedOrganizations && Array.isArray(trustedOrganizations) && trustedOrganizations.length > 0 && trustedOrganizations.map((trustedOrganization)=>{
                        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                            title: trustedOrganization.imgAlt,
                            sx: {
                                "& img": {
                                    aspectRatio: "3/2"
                                },
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomImage/* default */.Z, {
                                src: "".concat(env/* default.API_BASE */.Z.API_BASE).concat((ref = trustedOrganization === null || trustedOrganization === void 0 ? void 0 : trustedOrganization.img.data) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.attributes.url, "?updatedAt=").concat(trustedOrganization === null || trustedOrganization === void 0 ? void 0 : (ref2 = trustedOrganization.img) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[0]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.attributes) === null || ref5 === void 0 ? void 0 : ref5.updatedAt),
                                alt: trustedOrganization.imgAlt || "",
                                width: (trustedOrganization === null || trustedOrganization === void 0 ? void 0 : (ref6 = trustedOrganization.img) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : (ref8 = ref7[0]) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.attributes) === null || ref9 === void 0 ? void 0 : ref9.width) || 1000,
                                height: (trustedOrganization === null || trustedOrganization === void 0 ? void 0 : (ref10 = trustedOrganization.img) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.data) === null || ref11 === void 0 ? void 0 : (ref12 = ref11[0]) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.attributes) === null || ref13 === void 0 ? void 0 : ref13.height) || 1000
                            })
                        }, trustedOrganization.id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var trustedOrganizations_TrustedOrganizations = (TrustedOrganizations);

;// CONCATENATED MODULE: ./src/components/@common/trustedOrganizations/TrustedOrganizations.style.ts


const TrustedContainer = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingBlock: theme.spacing(8),
        paddingInline: theme.spacing(2),
        backgroundColor: theme.palette.global01[700],
        borderRadius: theme.spacing(4)
    };
});
const TrustedOrganizations_style_Title = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        [theme.breakpoints.down("md")]: {
            maxWidth: 290
        }
    };
});
const TrustedLogos = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        marginTop: theme.spacing(4),
        gridTemplateColumns: "repeat(6, 1fr)",
        display: "grid",
        gridAutoRows: "auto",
        gridAutoColumns: "auto",
        alignItems: "center",
        // justifyContent: 'space-between',
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "repeat(3, 1fr)"
        },
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: "repeat(2, 1fr)"
        }
    };
});

;// CONCATENATED MODULE: ./src/components/@common/trustedOrganizations/index.ts



;// CONCATENATED MODULE: ./src/components/@common/VacanciesSection/VacanciesSection.style.ts


const VacanciesSection_style_Section = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$margin"
})((param)=>{
    let { theme , $margin  } = param;
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: theme.spacing(2),
        marginTop: [
            "both",
            "top"
        ].includes($margin) ? theme.spacing(15) : 0,
        marginBottom: [
            "both",
            "bottom"
        ].includes($margin) ? theme.spacing(15) : 0,
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            marginTop: [
                "both",
                "top"
            ].includes($margin) ? theme.spacing(6) : 0,
            marginBottom: [
                "both",
                "bottom"
            ].includes($margin) ? theme.spacing(6) : 0,
            gap: theme.spacing(4)
        }
    };
});
const VacanciesSection_style_SectionLeft = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$fullwidth"
})((param)=>{
    let { theme , $fullwidth  } = param;
    return {
        width: $fullwidth ? "100%" : "50%",
        gap: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        [theme.breakpoints.down("md")]: {
            width: "100%"
        }
    };
});
const VacanciesSection_style_SectionRight = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        width: "50%",
        display: "flex",
        alignItems: "center",
        position: "relative",
        [theme.breakpoints.down("md")]: {
            width: "100%"
        }
    };
});
const VacanciesSection_style_SectionTitle = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.neutral01[200],
        margin: 0
    };
});
const VacanciesSection_style_Description = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        maxWidth: "666px",
        color: theme.palette.text.secondary,
        [theme.breakpoints.down("sm")]: {
            maxWidth: "343px"
        }
    };
});
const VacanciesSectionCards = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$columns"
})((param)=>{
    let { theme , $columns  } = param;
    return {
        width: "100%",
        display: "grid",
        gridTemplateColumns: "repeat(".concat($columns, ", 1fr)"),
        gap: theme.spacing(3),
        marginTop: theme.spacing(6),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr"
        }
    };
});
const VacanciesSectionCard = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "grid",
        flexDirection: "column",
        justifyContent: "space-between",
        borderRadius: theme.spacing(1),
        gap: theme.spacing(1),
        border: "1px solid ".concat(theme.palette.neutral01[600]),
        padding: theme.spacing(3, 2),
        [theme.breakpoints.down("md")]: {
            margin: "0 auto",
            width: "100%"
        }
    };
});
const VacanciesSection_style_ButtonsContainer = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "column",
        marginTop: theme.spacing(2),
        gap: theme.spacing(2),
        [theme.breakpoints.down("md")]: {
            gap: theme.spacing(1),
            margin: "0 auto",
            width: "100%"
        }
    };
});
const VacanciesSection_style_Title = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: theme.spacing(1)
    };
});
const VacanciesSection_style_MoreDetailButton = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        color: theme.palette.primary.main,
        fill: theme.palette.primary.main,
        "&:hover": {
            color: theme.palette.global01[300],
            fill: theme.palette.global01[300],
            gap: theme.spacing(0.5)
        }
    };
});

;// CONCATENATED MODULE: ./src/components/@common/VacanciesSection/index.ts



;// CONCATENATED MODULE: ./src/components/@common/VacanciesSection/VacanciesSection.tsx
















const VacanciesSection = (param)=>{
    let { icon , tagline , title , description , image , margin ="both" , headerSize ="small" , titleMaxWidth ="none" , isHeroSection =false , inverted =false , invertedMobile =false  } = param;
    const { isSmall , isMedium  } = (0,useMedia/* default */.Z)();
    const { locale  } = (0,useLocale/* useLocale */.b)();
    const { 0: jobs , 1: setJobs  } = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        if (locale) {
            loadData(localConvert/* languageCodeMap */.B[locale]);
        }
    }, [
        locale
    ]);
    const loadData = async (locale)=>{
        try {
            const response = await api/* JobsService.getAllJobs */.eC.getAllJobs("locale=".concat(locale));
            if (response && (response === null || response === void 0 ? void 0 : response.data)) {
                setJobs(response === null || response === void 0 ? void 0 : response.data);
            } else {
                setJobs([]);
            }
        } catch (error) {
            esm_exports/* captureException */.Tb(error);
        // Even if the API failed, we still go to the next step, but hide description in the Organisation step
        } finally{}
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VacanciesSection_style_Section, {
            component: "section",
            $margin: margin,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VacanciesSection_style_SectionLeft, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, !isMedium ? {
                    order: inverted ? 1 : 0
                } : {
                    order: invertedMobile ? 1 : 0
                }), {
                    $fullwidth: false,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            tagline && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
                                direction: "row",
                                gap: 1,
                                sx: (theme)=>({
                                        color: theme.palette.neutral01[400],
                                        fill: theme.palette.neutral01[400]
                                    }),
                                children: [
                                    icon && /*#__PURE__*/ react.cloneElement(icon, {
                                        style: {
                                            width: "32px",
                                            height: "32px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                        variant: "heading04",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            id: tagline
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VacanciesSection_style_SectionTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                gutterBottom: true,
                                variant: tagline || headerSize === "large" ? "heading01" : "heading02"
                            }, isHeroSection && {
                                component: "h1"
                            }), {
                                maxWidth: titleMaxWidth,
                                children: title
                            })),
                            description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VacanciesSection_style_Description, {
                                variant: "paragraph01",
                                children: description
                            }),
                            jobs && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VacanciesSectionCards, {
                                $columns: 1,
                                children: jobs && Array.isArray(jobs) && jobs.map((job, i)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VacanciesSectionCard, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VacanciesSection_style_Title, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                                    fontWeight: 700,
                                                    variant: "heading04",
                                                    children: job.attributes.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VacanciesSection_style_Description, {
                                                variant: "paragraph01",
                                                children: job.attributes.description
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                href: "/jobs/".concat(job.attributes.url),
                                                style: {
                                                    display: "flex",
                                                    justifyContent: "flex-start",
                                                    alignItems: "center"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(VacanciesSection_style_MoreDetailButton, {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                                            fontWeight: 700,
                                                            variant: "paragraph02",
                                                            children: job.attributes.labelButton
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_icons/* IcoArrowRight */.ms, {
                                                            style: {
                                                                width: "9.5px",
                                                                height: "9px",
                                                                marginLeft: "7px"
                                                            }
                                                        })
                                                    ]
                                                })
                                            }),
                                            " "
                                        ]
                                    }, i))
                            })
                        ]
                    })
                })),
                image && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VacanciesSection_style_SectionRight, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, !isMedium ? {
                    order: inverted ? 0 : 1
                } : {
                    order: invertedMobile ? 0 : 1
                }), {
                    sx: (0,_object_spread/* default */.Z)({
                        justifyContent: !inverted ? "flex-end" : "flex-start"
                    }, isMedium && {
                        justifyContent: "center"
                    }, isSmall && {
                        justifyContent: "center"
                    }),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                        sx: {
                            position: "relative",
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            maxWidth: isHeroSection ? "564px" : "465px"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_common_CustomImage/* default */.Z, {
                            src: "".concat(env/* default.API_BASE */.Z.API_BASE).concat(image.img.data[0].attributes.url, "?updatedAt=").concat(image.img.data[0].attributes.updatedAt),
                            alt: image.imgAlt || "",
                            width: image.img.data[0].attributes.width,
                            height: image.img.data[0].attributes.height
                        })
                    })
                }))
            ]
        })
    });
};
/* harmony default export */ var VacanciesSection_VacanciesSection = (VacanciesSection);

// EXTERNAL MODULE: ./node_modules/@mui/material/InputLabel/InputLabel.js + 3 modules
var InputLabel = __webpack_require__(3841);
// EXTERNAL MODULE: ./node_modules/@mui/material/Select/Select.js + 5 modules
var Select = __webpack_require__(315);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 2 modules
var MenuItem = __webpack_require__(40);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(4853);
;// CONCATENATED MODULE: ./src/components/@contact-form/ContactFormContainer/ContactFormContainer.style.ts


const FormSection = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "grid",
        flexDirection: "column",
        width: "100%",
        justifyContent: "space-between",
        borderRadius: theme.spacing(1),
        gap: theme.spacing(3),
        backgroundColor: theme.palette.neutral01[700],
        gridTemplateColumns: "repeat(2, 1fr)",
        [theme.breakpoints.down("md")]: {
            margin: "0 auto",
            width: "100%",
            gridTemplateColumns: "repeat(1, 1fr)"
        }
    };
});
const FormSectionLeft = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        gap: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        [theme.breakpoints.down("md")]: {
            width: "100%"
        }
    };
});
const FormSectionRight = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        width: "50%",
        display: "flex",
        alignItems: "center",
        position: "relative",
        [theme.breakpoints.down("md")]: {
            width: "100%"
        }
    };
});

;// CONCATENATED MODULE: ./src/components/@contact-form/ContactFormContainer/ContactFormContainer.tsx




















const ContactFormContainer = (param)=>{
    let { title , descriptions  } = param;
    var ref;
    const intl = (0,useIntl/* default */.Z)();
    const { isMedium  } = (0,useMedia/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const { locale  } = (0,useLocale/* useLocale */.b)();
    const { serviceSlug  } = router.query;
    const services = (0,es/* useSelector */.v9)((state)=>state.serviceStore.services);
    const { handleSubmit , control , reset , formState: { errors  } ,  } = (0,index_esm/* useForm */.cI)();
    const { 0: isRecaptchaSuccess , 1: setIsRecaptchaSuccess  } = (0,react.useState)(false);
    const onChangeRecaptcha = ()=>{
        setIsRecaptchaSuccess(true);
    };
    const onSubmitForm = handleSubmit((data)=>{
        if (isRecaptchaSuccess) {
            if (data.service === "null") {
                delete data.service;
            }
            const dataForSubmit = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                locale: localConvert/* languageCodeMap */.B[locale]
            });
            dist/* toast.loading */.Am.loading(intl.formatMessage({
                id: "common.notification.loading"
            }));
            handleSubmitForm(dataForSubmit);
        }
    });
    const handleSubmitForm = async (data)=>{
        try {
            const response = await api/* ContactFormService.createNewEntry */.jh.createNewEntry(data);
            if (response && (response === null || response === void 0 ? void 0 : response.data)) {
                dist/* toast.dismiss */.Am.dismiss();
                dist/* toast.success */.Am.success(intl.formatMessage({
                    id: "common.notification.success"
                }));
                reset();
            } else {
                dist/* toast.error */.Am.error(intl.formatMessage({
                    id: "common.notification.error"
                }));
            }
        } catch (error) {
            dist/* toast.error */.Am.error(intl.formatMessage({
                id: "common.notification.error"
            }));
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        sx: {
            paddingBottom: 15,
            paddingTop: 15
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormSection, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormSectionLeft, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                            variant: "heading03",
                            component: "h3",
                            children: title
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
                            children: descriptions && Array.isArray(descriptions) && descriptions.map((description, index)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                    variant: "paragraph01",
                                    color: "neutral01.300",
                                    fontWeight: "normal",
                                    component: "p",
                                    sx: {
                                        marginTop: 1
                                    },
                                    children: description.description
                                }, index))
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                    mt: 3,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    sx: {
                        border: "1px solid ".concat(theme/* theme.palette.neutral01.600 */.r.palette.neutral01[600]),
                        padding: theme/* theme.spacing */.r.spacing(3),
                        borderRadius: theme/* theme.spacing */.r.spacing(2)
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InputLabel/* default */.Z, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                        color: theme/* theme.palette.global01 */.r.palette.global01,
                                        fontSize: 10,
                                        sx: {
                                            marginTop: 1
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            id: "contactForm.field_0"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Controller */.Qr, {
                                    name: "service",
                                    control: control,
                                    defaultValue: ((ref = services.find((service)=>service.attributes.url == serviceSlug)) === null || ref === void 0 ? void 0 : ref.id) || 0,
                                    rules: {
                                        required: true
                                    },
                                    render: (param)=>{
                                        let { field  } = param;
                                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Select/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                                                    ref: null,
                                                    error: errors.service ? true : false,
                                                    labelId: "demo-simple-select-label",
                                                    id: "demo-simple-select",
                                                    onChange: field.onChange,
                                                    sx: {
                                                        width: "100%",
                                                        position: "relative"
                                                    },
                                                    IconComponent: ()=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_icons/* IcoArrow */.EO, {
                                                            style: {
                                                                width: "32px",
                                                                height: "32px",
                                                                right: "16px",
                                                                position: "absolute",
                                                                pointerEvents: "none",
                                                                fill: theme/* theme.palette.global01.400 */.r.palette.global01[400]
                                                            }
                                                        }),
                                                    children: [
                                                        services && services.map((service)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
                                                                value: service.id,
                                                                children: service.attributes.title
                                                            }, service.id)),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem/* default */.Z, {
                                                            value: "null",
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                id: "contactForm.other.option"
                                                            })
                                                        }, 10000)
                                                    ]
                                                })),
                                                (errors === null || errors === void 0 ? void 0 : errors.service) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                                                    sx: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        flexDirection: "row",
                                                        marginTop: 1
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_icons/* IcoWarningFilled */.aT, {
                                                            height: 19,
                                                            width: 19,
                                                            fill: theme/* theme.palette.error.dark */.r.palette.error.dark
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                                            color: "error.dark",
                                                            fontSize: 14,
                                                            fontWeight: 400,
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                id: "contactForm.error.required"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        });
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Controller */.Qr, {
                            name: "name",
                            control: control,
                            defaultValue: "",
                            rules: {
                                required: true,
                                pattern: {
                                    value: regexUtils/* regexNoWhitespace */.l0,
                                    message: intl.formatMessage({
                                        id: "contactForm.field_2"
                                    })
                                }
                            },
                            render: (param)=>{
                                let { field  } = param;
                                var ref;
                                /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_common/* TextField */.nv, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                                    hasError: errors.name ? true : false,
                                    errorMessage: (errors === null || errors === void 0 ? void 0 : (ref = errors.name) === null || ref === void 0 ? void 0 : ref.type) == "required" ? "contactForm.error.required" : "contactForm.error.pattern",
                                    handleChange: (value)=>field.onChange(value),
                                    label: intl.formatMessage({
                                        id: "contactForm.field_2"
                                    })
                                }));
                            }
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Controller */.Qr, {
                            name: "email",
                            control: control,
                            defaultValue: "",
                            rules: {
                                required: true,
                                pattern: {
                                    value: regexUtils/* regexEmail */.Ej,
                                    message: intl.formatMessage({
                                        id: "contactForm.field_3"
                                    })
                                }
                            },
                            render: (param)=>{
                                let { field  } = param;
                                var ref;
                                /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_common/* TextField */.nv, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                                    label: intl.formatMessage({
                                        id: "contactForm.field_3"
                                    }),
                                    type: "email",
                                    hasError: errors.email ? true : false,
                                    errorMessage: (errors === null || errors === void 0 ? void 0 : (ref = errors.email) === null || ref === void 0 ? void 0 : ref.type) == "required" ? "contactForm.error.required" : "contactForm.error.pattern",
                                    handleChange: (value)=>field.onChange(value)
                                }));
                            }
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Controller */.Qr, {
                            name: "organization",
                            control: control,
                            defaultValue: "",
                            rules: {
                                required: true,
                                pattern: {
                                    value: regexUtils/* regexNoWhitespace */.l0,
                                    message: intl.formatMessage({
                                        id: "contactForm.field_4"
                                    })
                                }
                            },
                            render: (param)=>{
                                let { field  } = param;
                                var ref;
                                /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_common/* TextField */.nv, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                                    hasError: errors.organization ? true : false,
                                    errorMessage: (errors === null || errors === void 0 ? void 0 : (ref = errors.organization) === null || ref === void 0 ? void 0 : ref.type) == "required" ? "contactForm.error.required" : "contactForm.error.pattern",
                                    handleChange: (value)=>field.onChange(value),
                                    label: intl.formatMessage({
                                        id: "contactForm.field_4"
                                    })
                                }));
                            }
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Controller */.Qr, {
                            name: "phoneNumber",
                            control: control,
                            defaultValue: "",
                            rules: {
                                required: false,
                                pattern: {
                                    value: regexUtils/* regexPhoneNumber */.mJ,
                                    message: intl.formatMessage({
                                        id: "contactForm.field_5"
                                    })
                                }
                            },
                            render: (param)=>{
                                let { field  } = param;
                                var ref;
                                /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_common/* TextField */.nv, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                                    value: field.value || "",
                                    hasError: errors.phoneNumber ? true : false,
                                    errorMessage: (errors === null || errors === void 0 ? void 0 : (ref = errors.phoneNumber) === null || ref === void 0 ? void 0 : ref.type) == "required" ? "contactForm.error.required" : "contactForm.error.pattern",
                                    handleChange: (value)=>field.onChange(value),
                                    label: intl.formatMessage({
                                        id: "contactForm.field_5"
                                    })
                                }));
                            }
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Controller */.Qr, {
                            name: "ask",
                            control: control,
                            defaultValue: "",
                            rules: {
                                required: true,
                                pattern: {
                                    value: regexUtils/* regexNoWhitespace */.l0,
                                    message: intl.formatMessage({
                                        id: "contactForm.field_6"
                                    })
                                }
                            },
                            render: (param)=>{
                                let { field  } = param;
                                var ref;
                                /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_common/* TextField */.nv, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                                    handleChange: (value)=>field.onChange(value),
                                    hasError: errors.ask ? true : false,
                                    errorMessage: (errors === null || errors === void 0 ? void 0 : (ref = errors.ask) === null || ref === void 0 ? void 0 : ref.type) == "required" ? "contactForm.error.required" : "contactForm.error.pattern",
                                    label: intl.formatMessage({
                                        id: "contactForm.field_6"
                                    }),
                                    multiline: true
                                }));
                            }
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(esm/* default */.Z, {
                            sitekey: "6Ld7da8oAAAAAHQg8lXtyqMKgg1H4vBhOTOP603c",
                            onChange: onChangeRecaptcha
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                            variant: "contained",
                            size: "large",
                            fullWidth: isMedium ? true : false,
                            onClick: onSubmitForm,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                id: "contactForm.labelButtonSubmit"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var ContactFormContainer_ContactFormContainer = (ContactFormContainer);

;// CONCATENATED MODULE: ./src/components/@contact-form/ContactFormContainer/index.ts



;// CONCATENATED MODULE: ./src/components/@contact-form/index.ts


;// CONCATENATED MODULE: ./src/components/@homepage/direct/Direct.style.ts



const DirectContainer = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "column",
        marginBlock: theme.spacing(15),
        [theme.breakpoints.down("md")]: {
            marginBlock: theme.spacing(6)
        }
    };
});
const DirectCards = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$columns"
})((param)=>{
    let { theme , $columns  } = param;
    return {
        width: "100%",
        display: "grid",
        gridTemplateColumns: "repeat(".concat($columns, ", 1fr)"),
        gap: theme.spacing(3),
        marginTop: theme.spacing(6),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr"
        }
    };
});
const DirectCard = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        borderRadius: theme.spacing(2),
        border: "1px solid ".concat(theme.palette.neutral01[600]),
        padding: theme.spacing(3, 3),
        [theme.breakpoints.down("md")]: {
            margin: "0 auto",
            width: "100%"
        },
        "&:hover": {
            cursor: "pointer"
        }
    };
});
const Direct_style_Title = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: theme.spacing(1)
    };
});
const Direct_style_Description = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "block",
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(1),
        [theme.breakpoints.down("md")]: {
            marginBottom: theme.spacing(3)
        }
    };
});
const Divider = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        height: "1px",
        backgroundColor: theme.palette.neutral01[600],
        marginBlock: theme.spacing(3)
    };
});
const Features = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        marginBlock: theme.spacing(2, 3),
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1)
    };
});
const Feature = (0,styled/* default */.ZP)(Box/* default */.Z)(()=>({
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "8px"
    }));
const IcoCheckBoldGreen = (0,styled/* default */.ZP)(_icons/* IcoCheckBold */.zM)((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.success.main,
        minWidth: "24px",
        minHeight: "24px"
    };
});
const HiddenOnMobile = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        [theme.breakpoints.down("md")]: {
            display: "none"
        }
    };
});

;// CONCATENATED MODULE: ./src/components/@homepage/direct/Direct.tsx












const Direct = (param)=>{
    let { title , description  } = param;
    const router = (0,next_router.useRouter)();
    const { locale  } = (0,useLocale/* useLocale */.b)();
    const { 0: directs , 1: setDirects  } = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        if (locale) {
            loadData(localConvert/* languageCodeMap */.B[locale]);
        }
    }, [
        locale
    ]);
    const loadData = async (locale)=>{
        try {
            const response = await api/* DirectsService.getAllDirects */.G9.getAllDirects("locale=".concat(locale));
            if (response && (response === null || response === void 0 ? void 0 : response.data)) {
                setDirects(response === null || response === void 0 ? void 0 : response.data);
            } else {
                setDirects([]);
            }
        } catch (error) {
            esm_exports/* captureException */.Tb(error);
        // Even if the API failed, we still go to the next step, but hide description in the Organisation step
        } finally{}
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DirectContainer, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                    sx: (theme)=>({
                            display: "flex",
                            flexDirection: "column",
                            gap: theme.spacing(2)
                        }),
                    children: [
                        title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                            sx: {
                                textAlign: {
                                    sm: "left",
                                    md: "center"
                                }
                            },
                            variant: "heading02",
                            children: title
                        }),
                        description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                            sx: (theme)=>({
                                    color: theme.palette.text.secondary,
                                    textAlign: {
                                        sm: "left",
                                        md: "center"
                                    }
                                }),
                            variant: "paragraph01",
                            children: description
                        })
                    ]
                }),
                directs && Array.isArray(directs) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DirectCards, {
                    $columns: directs.length,
                    children: directs && directs.map((direct, i)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DirectCard, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Direct_style_Title, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                        fontWeight: 700,
                                        variant: "heading04",
                                        children: direct.attributes.title
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Direct_style_Description, {
                                    variant: "paragraph01",
                                    children: direct.attributes.description
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: "".concat(direct.attributes.url),
                                    rel: "noopener noreferrer",
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                                        sx: {
                                            alignItems: "center",
                                            justifyContent: "flex-start",
                                            display: "flex",
                                            color: theme/* theme.palette.primary.main */.r.palette.primary.main,
                                            fill: theme/* theme.palette.primary.main */.r.palette.primary.main,
                                            marginTop: theme/* theme.spacing */.r.spacing(2),
                                            "&:hover": {
                                                color: theme/* theme.palette.global01.300 */.r.palette.global01[300],
                                                fill: theme/* theme.palette.global01.300 */.r.palette.global01[300],
                                                gap: theme/* theme.spacing */.r.spacing(0.5)
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                                fontWeight: 700,
                                                variant: "paragraph02",
                                                children: direct.attributes.labelButton
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_icons/* IcoShare */.Nh, {
                                                style: {
                                                    width: "25px",
                                                    height: "25px"
                                                }
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, i))
                })
            ]
        })
    });
};
/* harmony default export */ var direct_Direct = (Direct);

// EXTERNAL MODULE: ./src/components/@common/GlobalForm/GlobalForm.tsx + 20 modules
var GlobalForm = __webpack_require__(352);
;// CONCATENATED MODULE: ./src/components/@homepage/getStarted/GetStarted.tsx






const GetStarted = (param)=>{
    let { title , description , labelButton  } = param;
    const { isSmall  } = (0,useMedia/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        sx: {
            marginBottom: {
                lg: theme/* theme.spacing */.r.spacing(15),
                sm: theme/* theme.spacing */.r.spacing(5),
                md: theme/* theme.spacing */.r.spacing(15),
                xs: theme/* theme.spacing */.r.spacing(5)
            }
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GetStartedContainer, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GetStarted_style_Title, {
                    variant: "heading03",
                    children: title
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GetStarted_style_Description, {
                    fontWeight: "700",
                    variant: "heading05",
                    children: description
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GetStarted_style_ButtonsContainer, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                        size: "large",
                        fullWidth: !isSmall ? false : true,
                        variant: "contained",
                        color: "secondary",
                        onClick: ()=>GlobalForm/* globalModal.show */.Fj.show(),
                        children: labelButton
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var getStarted_GetStarted = (GetStarted);

;// CONCATENATED MODULE: ./src/components/@homepage/getStarted/GetStarted.style.ts


const GetStartedContainer = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        width: "100%",
        backgroundColor: theme.palette.global01[400],
        borderRadius: theme.spacing(4),
        padding: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(1),
        [theme.breakpoints.down("md")]: {
            padding: theme.spacing(5, 4),
            gap: theme.spacing(2)
        }
    };
});
const GetStarted_style_Title = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.neutral01[700]
    };
});
const GetStarted_style_Description = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        maxWidth: 540,
        color: theme.palette.neutral01[700],
        [theme.breakpoints.down("md")]: {
            width: "100%"
        }
    };
});
const GetStarted_style_ButtonsContainer = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "row",
        marginTop: theme.spacing(2),
        gap: theme.spacing(2),
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            gap: theme.spacing(1)
        }
    };
});

;// CONCATENATED MODULE: ./src/components/@homepage/getStarted/index.ts



// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 3 modules
var Accordion = __webpack_require__(2280);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(8895);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(2797);
;// CONCATENATED MODULE: ./src/components/@homepage/questions/Questions.tsx






const Questions = (param)=>{
    let { title , questions  } = param;
    const { 0: expanded , 1: setExpanded  } = (0,react.useState)(false);
    const handleChange = (panel)=>(_, isExpanded)=>{
            setExpanded(isExpanded ? panel : false);
        };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        sx: {
            background: theme/* theme.palette.global01.700 */.r.palette.global01[700],
            minWidth: "100%",
            padding: 0
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(QuestionsSection, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuestionsLeft, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                            variant: "heading02",
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuestionsRight, {
                        children: questions && questions.map((param, index)=>/*#__PURE__*/ {
                            let { question , answer  } = param;
                            return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Accordion/* default */.Z, {
                                expanded: expanded === "panel".concat(index + 1),
                                onChange: handleChange("panel".concat(index + 1)),
                                "aria-controls": "panel".concat(index + 1, "bh-content"),
                                "aria-expanded": expanded === "panel".concat(index + 1),
                                "aria-label": "Expand question",
                                id: "panel".concat(index + 1, "bh-header"),
                                sx: {
                                    background: theme/* theme.palette.global01.700 */.r.palette.global01[700]
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionSummary/* default */.Z, {
                                        expandIcon: expanded === "panel".concat(index + 1) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_icons/* IcoMinus */.Wt, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_icons/* IcoPlus */.ac, {}),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                            variant: "heading05",
                                            children: question
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionDetails/* default */.Z, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                            variant: "paragraph01",
                                            sx: (theme)=>({
                                                    color: theme.palette.neutral01[300]
                                                }),
                                            children: answer
                                        })
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var questions_Questions = (Questions);

;// CONCATENATED MODULE: ./src/components/@homepage/questions/Questions.style.ts


const QuestionsSection = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        paddingBlock: theme.spacing(15),
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: theme.spacing(3),
        background: theme.palette.global01["700"],
        [theme.breakpoints.down("md")]: {
            padding: 0,
            gridTemplateColumns: "1fr",
            gap: theme.spacing(2)
        },
        [theme.breakpoints.down("lg")]: {
            padding: 0,
            gridTemplateColumns: "1fr",
            paddingBlock: theme.spacing(6),
            gap: theme.spacing(2)
        }
    };
});
const QuestionsLeft = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        background: theme.palette.global01["700"]
    };
});
const QuestionsRight = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        marginTop: theme.spacing(-2),
        background: theme.palette.global01["700"]
    };
});

;// CONCATENATED MODULE: ./src/components/@homepage/questions/index.ts



;// CONCATENATED MODULE: ./src/components/@common/TitleSection/TitleSection.tsx



















const TitleSection = (param)=>{
    let { icon , tagline , title , description , checks , primaryButton , secondaryButton , thirdButton , forthButton , openNewTabButton , image , margin ="both" , headerSize ="small" , imgMaxWidth , titleMaxWidth ="none" , isHeroSection =false , inverted =false , invertedMobile =false , getEvents =false , dateForEvent  } = param;
    const { isSmall , isMedium  } = (0,useMedia/* default */.Z)();
    const router = (0,next_router.useRouter)();
    const { locale  } = (0,useLocale/* useLocale */.b)();
    const { eventSlug  } = router.query;
    const IcoCheckBoldGreen = (0,styled/* default */.ZP)(_icons/* IcoCheckBold */.zM)((param)=>{
        let { theme  } = param;
        return {
            color: theme.palette.success.main,
            minWidth: "24px",
            minHeight: "24px"
        };
    });
    const { 0: events , 1: setEvents  } = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        if (locale && getEvents) {
            loadData(localConvert/* languageCodeMap */.B[locale]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        locale,
        getEvents,
        eventSlug
    ]);
    const loadData = async (locale)=>{
        try {
            let getEvent;
            if (eventSlug) {
                getEvent = {
                    sort: {
                        date: "ASC"
                    },
                    locale: locale,
                    filters: {
                        url: {
                            $ne: "".concat(eventSlug)
                        }
                    }
                };
            } else {
                getEvent = {
                    sort: {
                        date: "ASC"
                    },
                    locale: locale
                };
            }
            const response = await api/* EventsService.getAllEvents */.nC.getAllEvents(lib_default().stringify(getEvent, {
                encodeValuesOnly: true
            }));
            if (response && (response === null || response === void 0 ? void 0 : response.data)) {
                if (Array.isArray(response === null || response === void 0 ? void 0 : response.data) && (response === null || response === void 0 ? void 0 : response.data.length) > 3) {
                    setEvents(response === null || response === void 0 ? void 0 : response.data.splice(0, 3));
                } else {
                    setEvents(response === null || response === void 0 ? void 0 : response.data);
                }
            } else {
                setEvents([]);
            }
        } catch (error) {
            esm_exports/* captureException */.Tb(error);
        // Even if the API failed, we still go to the next step, but hide description in the Organisation step
        } finally{}
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TitleSection_style_Section, {
            component: "section",
            $margin: margin,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TitleSection_style_SectionLeft, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, !isMedium ? {
                    order: inverted ? 1 : 0
                } : {
                    order: invertedMobile ? 1 : 0
                }), {
                    $fullwidth: !image,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            tagline && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
                                direction: "row",
                                gap: 1,
                                sx: (theme)=>({
                                        color: theme.palette.neutral01[400],
                                        fill: theme.palette.neutral01[400]
                                    }),
                                children: [
                                    icon && /*#__PURE__*/ react.cloneElement(icon, {
                                        style: {
                                            width: "32px",
                                            height: "32px"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                        variant: "heading04",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            id: tagline
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TitleSection_style_SectionTitle, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                gutterBottom: true,
                                variant: tagline || headerSize == "large" ? "heading01" : "heading03"
                            }, isHeroSection && {
                                component: "h1"
                            }), {
                                maxWidth: titleMaxWidth,
                                children: title
                            })),
                            description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TitleSection_style_Description, {
                                variant: "paragraph01",
                                children: description
                            }),
                            getEvents && events && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TitleSectionCards, {
                                $columns: 1,
                                children: events && events.map((event, i)=>{
                                    var ref, ref1;
                                    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TitleSectionCard, {
                                        onClick: ()=>router.push("/events/".concat(event.attributes.url)),
                                        children: [
                                            ((ref = event.attributes) === null || ref === void 0 ? void 0 : ref.date) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(convertDatetoImage, {
                                                date: (ref1 = event.attributes) === null || ref1 === void 0 ? void 0 : ref1.date
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TitleSectionCardRight, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TitleSection_style_Title, {
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                                            fontWeight: 700,
                                                            variant: "heading05",
                                                            children: event.attributes.title
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TitleSection_style_Description, {
                                                        variant: "paragraph02",
                                                        children: event.attributes.description
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                        href: "/events/".concat(event.attributes.url),
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TitleSection_style_MoreDetailButton, {
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                                                    fontWeight: 700,
                                                                    variant: "paragraph02",
                                                                    children: event.attributes.labelButton
                                                                }),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_icons/* IcoArrowRight */.ms, {
                                                                    width: "9.5px",
                                                                    height: "9px",
                                                                    style: {
                                                                        marginLeft: "7px"
                                                                    }
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, i);
                                })
                            }),
                            checks && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Stack/* default */.Z, {
                                gap: 1,
                                children: checks.map((check, index)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stack/* default */.Z, {
                                        direction: "row",
                                        gap: 1,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IcoCheckBoldGreen, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
                                                sx: (theme)=>({
                                                        color: theme.palette.text.secondary
                                                    }),
                                                variant: "paragraph02",
                                                children: check.title
                                            })
                                        ]
                                    }, index))
                            }),
                            primaryButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: primaryButton.url,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                    size: "large",
                                    fullWidth: isMedium ? true : false,
                                    variant: "contained",
                                    color: "primary",
                                    children: primaryButton.label
                                })
                            }),
                            secondaryButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: secondaryButton.url,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                    size: "large",
                                    variant: "outlined",
                                    fullWidth: isMedium ? true : false,
                                    children: secondaryButton.label
                                })
                            }),
                            thirdButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: thirdButton.url,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button/* default */.Z, {
                                    size: "large",
                                    variant: "outlined",
                                    fullWidth: isMedium ? true : false,
                                    children: [
                                        thirdButton.label,
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_icons/* IcoShare */.Nh, {
                                            width: "24px",
                                            height: "24px"
                                        })
                                    ]
                                })
                            }),
                            forthButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: forthButton.url,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                    size: "large",
                                    variant: "contained",
                                    color: "primary",
                                    children: forthButton.label
                                })
                            }),
                            openNewTabButton && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: openNewTabButton.url,
                                rel: "noopener noreferrer",
                                target: "_blank",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Button/* default */.Z, {
                                    size: "large",
                                    variant: "outlined",
                                    color: "primary",
                                    fullWidth: isMedium ? true : false,
                                    children: [
                                        openNewTabButton.label,
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_icons/* IcoShare */.Nh, {
                                            width: "24px",
                                            height: "24px"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })),
                (image || dateForEvent) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TitleSection_style_SectionRight, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, !isMedium ? {
                    order: inverted ? 0 : 1
                } : {
                    order: invertedMobile ? 0 : 1
                }), {
                    sx: (0,_object_spread/* default */.Z)({
                        justifyContent: !inverted ? "center" : "flex-start"
                    }, isMedium && {
                        justifyContent: "center"
                    }, isSmall && {
                        justifyContent: "center"
                    }),
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
                        sx: {
                            position: "relative",
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            maxWidth: imgMaxWidth ? imgMaxWidth : isHeroSection ? "564px" : "465px"
                        },
                        children: [
                            dateForEvent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(convertDatetoImage, {
                                date: dateForEvent,
                                isHeroSection: true
                            }),
                            image && !dateForEvent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_common_CustomImage/* default */.Z, {
                                src: "".concat(env/* default.API_BASE */.Z.API_BASE).concat(image.img.data[0].attributes.url, "?updatedAt=").concat(image.img.data[0].attributes.updatedAt),
                                alt: image.imgAlt || "",
                                width: image.img.data[0].attributes.width,
                                height: image.img.data[0].attributes.height
                            })
                        ]
                    })
                }))
            ]
        })
    });
};
/* harmony default export */ var TitleSection_TitleSection = (TitleSection);

;// CONCATENATED MODULE: ./src/components/@common/TitleSection/TitleSection.style.ts


const TitleSection_style_Section = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$margin"
})((param)=>{
    let { theme , $margin  } = param;
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: theme.spacing(3),
        marginTop: [
            "both",
            "top"
        ].includes($margin) ? theme.spacing(15) : 0,
        marginBottom: [
            "both",
            "bottom"
        ].includes($margin) ? theme.spacing(15) : 0,
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            marginTop: [
                "both",
                "top"
            ].includes($margin) ? theme.spacing(6) : 0,
            marginBottom: [
                "both",
                "bottom"
            ].includes($margin) ? theme.spacing(6) : 0,
            gap: theme.spacing(4)
        }
    };
});
const TitleSection_style_SectionLeft = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$fullwidth"
})((param)=>{
    let { theme , $fullwidth  } = param;
    return {
        width: $fullwidth ? "100%" : "50%",
        gap: theme.spacing(2),
        display: "flex",
        flexDirection: "column",
        [theme.breakpoints.down("md")]: {
            width: "100%"
        }
    };
});
const TitleSection_style_SectionRight = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        width: "50%",
        display: "flex",
        alignItems: "center",
        position: "relative",
        [theme.breakpoints.down("md")]: {
            width: "100%"
        }
    };
});
const TitleSection_style_SectionTitle = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        color: theme.palette.neutral01[200],
        margin: 0
    };
});
const TitleSection_style_Description = (0,styled/* default */.ZP)(Typography/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        maxWidth: "666px",
        color: theme.palette.text.secondary,
        [theme.breakpoints.down("sm")]: {
            maxWidth: "643px"
        }
    };
});
const TitleSectionCards = (0,styled/* default */.ZP)(Box/* default */.Z, {
    shouldForwardProp: (prop)=>prop !== "$columns"
})((param)=>{
    let { theme , $columns  } = param;
    return {
        width: "100%",
        display: "grid",
        gridTemplateColumns: "repeat(".concat($columns, ", 1fr)"),
        gap: theme.spacing(3),
        marginTop: theme.spacing(6),
        [theme.breakpoints.down("md")]: {
            gridTemplateColumns: "1fr",
            marginTop: theme.spacing(2)
        }
    };
});
const TitleSectionCard = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "grid",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "flex-start",
        borderRadius: theme.spacing(2),
        gridTemplateColumns: "1fr 9fr",
        gap: theme.spacing(3),
        border: "1px solid ".concat(theme.palette.neutral01[600]),
        padding: theme.spacing(3, 2),
        [theme.breakpoints.down("md")]: {
            margin: "0 auto",
            width: "100%"
        },
        "&:hover": {
            cursor: "pointer"
        }
    };
});
const TitleSection_style_ButtonsContainer = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "column",
        marginTop: theme.spacing(2),
        gap: theme.spacing(2),
        [theme.breakpoints.down("md")]: {
            gap: theme.spacing(1),
            margin: "0 auto",
            width: "100%"
        }
    };
});
const TitleSectionCardRight = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "grid",
        flexDirection: "column",
        justifyContent: "space-between",
        borderRadius: theme.spacing(1)
    };
});
const TitleSection_style_Title = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: theme.spacing(1)
    };
});
const TitleSection_style_MoreDetailButton = (0,styled/* default */.ZP)(Box/* default */.Z)((param)=>{
    let { theme  } = param;
    return {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        color: theme.palette.primary.main,
        fill: theme.palette.primary.main,
        marginTop: theme.spacing(2),
        "&:hover": {
            color: theme.palette.global01[300],
            fill: theme.palette.global01[300],
            gap: theme.spacing(0.5)
        }
    };
});

;// CONCATENATED MODULE: ./src/components/@common/TitleSection/index.ts



;// CONCATENATED MODULE: ./src/utils/convert.tsx


















// eslint-disable-next-line @typescript-eslint/no-explicit-any
const componentMapping = {
    "section.carousel": Carousel_Carousel,
    "section.default-section": DefaultSection_DefaultSection,
    "section.trusted-organizations": trustedOrganizations_TrustedOrganizations,
    "section.service-section": ServiceSection_ServiceSection,
    "section.direct": direct_Direct,
    "section.get-started": getStarted_GetStarted,
    "section.q-and-a": questions_Questions,
    "section.support": Support_Support,
    "section.team-section": TeamSection_TeamSection,
    "section.vacancies-section": VacanciesSection_VacanciesSection,
    "section.other-say-section": OtherSaySection_OtherSaySection,
    "section.provision-section": ProvisionSection,
    "section.content-page": InfoPage,
    "section.contact-form": ContactFormContainer_ContactFormContainer,
    "section.search-event-section": SeacrchEventSection_SeacrchEventSection,
    "section.title-section": TitleSection_TitleSection
};
const LayoutRenderer = (param)=>{
    let { layout  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: layout.map((section, index)=>{
            const SectionComponent = componentMapping[section.__component];
            if (!SectionComponent) return null;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionComponent, (0,_object_spread/* default */.Z)({}, section), index);
        })
    });
};
/* harmony default export */ var convert = (LayoutRenderer);


/***/ })

}]);